// webhookTemplatesData
// Stores JSON data structure representing different integration webhook templates
export default {
    wcf_custom_ping: {
        fields: {
            output_tag_prefix: 'webhook_output_12345',

            ping_url: 'https://example.com/ping',
            ping_method: 'POST',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: ""
        },
        template_summary: {
            template_summary_text: ""
        },
        template_steps: {
            template_steps_text: ""
        },
        template_required_parameters: []
    },
    wcf_custom_ping_post: {
        fields: {
            output_tag_prefix: 'webhook_output_12345',

            ping_url: 'https://example.com/ping',
            ping_method: 'POST',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{}}',

            post_condition_key: 'placeholder',
            post_condition_operator: 'is_equal',
            post_condition_value: 'true',

            post_url: 'https://example.com/post',
            post_method: 'POST',
            post_headers: '',
            post_data: '',
            post_output_map: '{"PostOutputMap":{}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: ""
        },
        template_summary: {
            template_summary_text: ""
        },
        template_steps: {
            template_steps_text: ""
        },
        template_required_parameters: []
    },
    tld_agent_availability_public_dialer: {
        fields: {
            output_tag_prefix: 'tld_12345',

            ping_url: 'https://TEMPLATE_URL.tldcrm.com/api/public/dialer/ready/[nanp_caller_number]?ava=1&ing=99999',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"ready":"ready"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_ready' as the key, \n'greater than' as the operator, \n'0' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the TLD Agent Availability API to request a numeric 'ready' response value representing the number of agents ready to take a call. If the 'ready' response value is above 0, Retreaver will open the TLD integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the TLD integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by TLD.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "tld_url",
                property_name: "TLD API Url",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://TEMPLATE_URL.tldcrm.com/api/public/dialer/ready/[nanp_caller_number]?ava=1&ing=99999"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_ready",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    ringba_rtb_ping_post: {
        fields: {
            output_tag_prefix: 'ringba_12345',

            ping_url: 'https://rtb.ringba.com/v1/production/TEMPLATE_RTB_ID.json',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"CID":"[nanp_caller_number]","state":"[caller_state]","zipCode":"[caller_zip]","exposeCallerId":"yes"}',
            ping_output_map: '{"PingOutputMap":{"number":"phoneNumber","bid":"bidAmount","timer":"bidTerms[0].callMinDuration"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Ringba RTB API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the RTB request returns a valid transfer number, Retreaver will open the Ringba RTB integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Ringba RTB integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Ringba.\n\n3) Optionally, update the 'Ping Data' field if you would like to submit additional caller data along with the request.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "rtb_id",
                property_name: "Ringba RTB ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_RTB_ID"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    track_drive_ping_post: {
        fields: {
            output_tag_prefix: 'trackdrive_12345',

            ping_url: 'https://TEMPLATE_URL.trackdrive.com/api/v1/inbound_webhooks/ping/TEMPLATE_URL?trackdrive_number=+18551231234&traffic_source_id=TEMPLATE_SOURCE_ID&caller_id=[nanp_caller_number]',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"status":"status","ping_id":"buyers[0].ping_id","timer":"buyers[0].offer_conversion_duration OR current_conversion_duration","bid":"buyers[0].offer_conversion_payout"}}',

            post_condition_key: 'status',
            post_condition_operator: 'is_equal',
            post_condition_value: 'accepted',

            post_url: 'https://TEMPLATE_URL.trackdrive.com/api/v1/inbound_webhooks/post/TEMPLATE_URL?trackdrive_number=+18551231234&traffic_source_id=TEMPLATE_SOURCE_ID&caller_id=[nanp_caller_number]&ping_id=<podd_start>ping_id<podd_end>',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            post_data: '',
            post_output_map: '{"PostOutputMap":{"forwarding_number_status":"forwarding_number_status","number":"forwarding_number"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the TrackDrive API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the TrackDrive request returns a valid transfer number, Retreaver will open the TrackDrive integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the TrackDrive integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by TrackDrive, update the 'TEMPLATE_URL' and then update the 'trackdrive_number' and 'traffic_source_id' url parameters with the values provided by TrackDrive.\n\n3) Update the 'Post URL' field to match with the instructions provided by TrackDrive, update the 'TEMPLATE_URL' and then update the 'trackdrive_number' and 'traffic_source_id' url parameters with the values provided by TrackDrive.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "trackdrive_ping_url",
                property_name: "TrackDrive Ping URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://TEMPLATE_URL.trackdrive.com/api/v1/inbound_webhooks/ping/TEMPLATE_URL"
            },
            {
                property_id: "trackdrive_post_url",
                property_name: "TrackDrive Post URL",
                fields_to_replace: [
                    "post_url"
                ],
                replacement_token: "https://TEMPLATE_URL.trackdrive.com/api/v1/inbound_webhooks/post/TEMPLATE_URL"
            },
            {
                property_id: "trackdrive_number",
                property_name: "TrackDrive Number",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "+18551231234"
            },
            {
                property_id: "traffic_source_id",
                property_name: "TrackDrive Source ID",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_SOURCE_ID"
            },
            {
                property_id: "timer_output_tag",
                property_name: "TrackDrive Conversion Timer Output Key",
                fields_to_replace: [
                    "ping_output_map"
                ],
                replacement_token: "offer_conversion_duration OR current_conversion_duration"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    enhance_availability: {
        fields: {
            output_tag_prefix: 'enhance_agent_12345',

            ping_url: 'https://availability.enhance.tools/api/v1/call?api=TEMPLATE_API_KEY&phone=[nanp_caller_number]',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"ok":"ok","available":"available"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a boolean tag type, enter the following: \n'OUTPUT_TAG_PREFIX_available' as the key, \n'equals' as the operator, \n'true' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Enhance Agent Availability API to request a boolean 'available' response value representing if an agent is available to take a call. If the 'available' response equals 'true', Retreaver will open the Enhance integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Enhance integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Enhance.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_key",
                property_name: "Enhance API Key",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_available",
                "operator": "==",
                "value": "true"
            }
        ]
    },
    convoso_availability_agent_monitor: {
        fields: {
            output_tag_prefix: 'consovo_12345',

            ping_url: 'https://api.convoso.com/v1/agent-monitor/search?auth_token=TEMPLATE_AUTH_TOKEN&queue_id=12345&campaign_id=67890',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"available_agents":"data.available_agents"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_available_agents' as the key, \n'greater_than' as the operator, \n'0' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Convoso Agent Availability API to request a numeric 'available_agents' response value representing if an agent is available to take a call. If the 'available_agents' response is greater than '0', Retreaver will open the Convoso integrated buyer for routing.\n\nNOTE: This API endpoint returns a large output response message, we recommend that you use the 'user-activity' API variant instead which must first be enabled by the Convoso account managers."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Convoso integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Convoso.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_url",
                property_name: "Convoso API URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://api.convoso.com/v1/agent-monitor/search?auth_token=TEMPLATE_AUTH_TOKEN&queue_id=12345&campaign_id=67890"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_available_agents",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    convoso_availability_user_activity: {
        fields: {
            output_tag_prefix: 'consovo_12345',

            ping_url: 'https://api.convoso.com/v1/user-activity/search?auth_token=TEMPLATE_AUTH_TOKEN&queue_id=12345&campaign_id=67890',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"available_agents":"data.available_agents"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_available_agents' as the key, \n'greater_than' as the operator, \n'0' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Convoso Agent Availability API to request a numeric 'available_agents' response value representing if an agent is available to take a call. If the 'available_agents' response is greater than '0', Retreaver will open the Convoso integrated buyer for routing.\n\nNOTE: This API endpoint is the optimized version of the 'agent-monitor' API endpoint, however please ensure that it has been enabled by the Convoso account managers first prior to implementing it on your Retreaver buyer."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Convoso integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Convoso.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_url",
                property_name: "Convoso API URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://api.convoso.com/v1/user-activity/search?auth_token=TEMPLATE_AUTH_TOKEN&queue_id=12345&campaign_id=67890"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_available_agents",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    leadspedia_ping_post: {
        fields: {
            output_tag_prefix: 'leadspedia_12345',

            ping_url: 'https://TEMPLATE_URL.leadspediatrack.com/call-ping.do?lp_campaign_id=TEMPLATE_CAMPAIGN_ID&lp_campaign_key=TEMPLATE_CAMPAIGN_KEY&caller_id=[nanp_caller_number]&zip_code=[caller_zip]',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"status":"status","request_number_url":"request_number_url"}}',

            post_condition_key: 'status',
            post_condition_operator: 'is_equal',
            post_condition_value: 'Accepted',

            post_url: '<podd_start>request_number_url<podd_end>',
            post_method: 'GET',
            post_headers: '',
            post_data: '',
            post_output_map: '{"PostOutputMap":{"number":"number","timer":"duration","bid":"payout"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Leadspedia API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Leadspedia request returns a valid transfer number, Retreaver will open the Leadspedia integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Leadspedia integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Leadspedia, update the 'TEMPLATE_URL' and then update the 'TEMPLATE_CAMPAIGN_ID' and 'TEMPLATE_CAMPAIGN_KEY' url parameters with the values provided by Leadspedia.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "leadspedia_ping_url",
                property_name: "Leadspedia Ping URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://TEMPLATE_URL.leadspediatrack.com/call-ping.do"
            },
            {
                property_id: "leadspedia_campaign_id",
                property_name: "Leadspedia Campaign ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_ID"
            },
            {
                property_id: "leadspedia_campaign_key",
                property_name: "Leadspedia Campaign Key",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_KEY"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    integriant_availability: {
        fields: {
            output_tag_prefix: 'integriant_12345',

            ping_url: 'https://api.integriant.com/call-transfers?partner_name=TEMPLATE_PARTNER_NAME&phone=[nanp_caller_number]&zipcode=[caller_zip]&state=[caller_state]&platform=b&vertical=u65',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"agents_available":"agentsAvailable"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a boolean tag type, enter the following: \n'OUTPUT_TAG_PREFIX_agents_available' as the key, \n'equals' as the operator, \n'true' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Integriant Agent Availability API to request a boolean 'agents_available' response value representing if an agent is available to take a call. If the 'agents_available' response equals 'true', Retreaver will open the Integriant integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Integriant integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Integriant, update the 'TEMPLATE_PARTNER_NAME' url parameter.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "partner_name",
                property_name: "Integriant Partner Name",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_PARTNER_NAME"
            },
            {
                property_id: "vertical",
                property_name: "Integriant Vertical",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "u65"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_agents_available",
                "operator": "==",
                "value": "true"
            },
        ]
    },
    connie_health_ping_post: {
        fields: {
            output_tag_prefix: 'connie_health_12345',

            ping_url: 'https://calls-api-prod.conniehealth.com/partner-calls/ping',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"partnerUuid":"TEMPLATE_PARTNER_UUID","customerZip":"[caller_zip]","customerGender":"[TEMPLATE_GENDER_TAG]","optin":"true"}',
            ping_output_map: '{"PingOutputMap":{"pingId":"pingId","status":"status","statusReason":"statusReason"}}',

            post_condition_key: 'status',
            post_condition_operator: 'is_equal',
            post_condition_value: 'accepted',

            post_url: 'https://calls-api-prod.conniehealth.com/partner-calls/post',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json"}',
            post_data: '{"pingId":"<podd_start>pingId<podd_end>","customerPhoneNumber":"[nanp_caller_number]"}',
            post_output_map: '{"PostOutputMap":{"post_pingId":"pingId","post_status":"status","post_statusReason":"statusReason","payoutInCents":"payoutInCents","number":"phoneNumber","timer":"requiredCallDuration","bid":"payoutInCents"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: 'bid',
            revshare_modifier_percentage: '0.01'
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Connie Health API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Connie Health request returns a valid transfer number, Retreaver will open the Connie Health integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Connie Health integrated buyer.\n\n2) Update the 'TEMPLATE_PARTNER_UUID' and then update the 'TEMPLATE_GENDER_TAG' values in the 'Ping Data' field with the values provided by Connie Health.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "partner_uuid",
                property_name: "Connie Partner UUID",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_PARTNER_UUID"
            },
            {
                property_id: "gender_value",
                property_name: "Caller Gender Value",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "[TEMPLATE_GENDER_TAG]"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    jangl_ping_post: {
        fields: {
            output_tag_prefix: 'jangl_12345',

            ping_url: 'https://calls-api.jangl.com/v1/ping',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","Authorization":"Token TEMPLATE_AUTHORIZATION_TOKEN"}',
            ping_data: '{"caller_phone":"[caller_number]","contact":{"state":"[caller_state]","zip_code":"[caller_zip]"}}',
            ping_output_map: '{"PingOutputMap":{"call_id":"call_id","bid_id":"bid.bid_id","bid":"bid.payout","timer":"bid.purchase_duration","transfer_name":"bid.transfer_name","success":"success"}}',

            post_condition_key: 'bid',
            post_condition_operator: 'is_greater_than',
            post_condition_value: '0',

            post_url: 'https://calls-api.jangl.com/v1/post',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json","Authorization":"Token TEMPLATE_AUTHORIZATION_TOKEN"}',
            post_data: '{"caller_phone":"[caller_number]","bid_id":"<podd_start>bid_id<podd_end>","contact":{"state":"[caller_state]","zip_code":"[caller_zip]"}}',
            post_output_map: '{"PostOutputMap":{"number":"phone_number","success":"success"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Jangl API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Jangl request returns a valid transfer number, Retreaver will open the Jangl integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Jangl integrated buyer.\n\n2) Update the 'Ping Headers' and 'Post Headers' TEMPLATE_AUTHORIZATION_TOKEN value to match with the values provided by Jangl.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "authorization_token",
                property_name: "Jangl Authorization Token",
                fields_to_replace: [
                    "ping_headers",
                    "post_headers"
                ],
                replacement_token: "TEMPLATE_AUTHORIZATION_TOKEN"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    media_alpha_ping_post: {
        fields: {
            output_tag_prefix: 'media_alpha_12345',

            ping_url: 'https://insurance.mediaalpha.com/call-transfers-ping.json',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"api_token":"TEMPLATE_API_TOKEN","call_type":"Inbound","data":{"zip":"[caller_zip]"},"ip":"","local_hour":12,"max":3,"placement_id":"TEMPLATE_PLACEMENT_ID","sub_1":"","transfer_type":"cold","ua":"","url":"","version":17}',
            ping_output_map: '{"PingOutputMap":{"ping_bid_id":"call_transfers[0].bid_id","ping_ping_id":"ping_id","ping_error":"error"}}',

            post_condition_key: 'ping_bid_id',
            post_condition_operator: 'exists',
            post_condition_value: '',

            post_url: 'https://insurance.mediaalpha.com/call-transfers-post.json',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json"}',
            post_data: '{"api_token":"TEMPLATE_API_TOKEN","bid_id":"<podd_start>ping_bid_id<podd_end>","call_type":"Outbound","data":{"zip":"[caller_zip]"},"ip":"","local_hour":12,"ping_id":"<podd_start>ping_ping_id<podd_end>","placement_id":"TEMPLATE_PLACEMENT_ID","transfer_type":"cold","url":"","version":17}',
            post_output_map: '{"PostOutputMap":{"bid":"bid","timer":"qualification_duration","number":"phone_num","post_error":"error"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Media Alpha API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Media Alpha request returns a valid transfer number, Retreaver will open the Media Alpha integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Media Alpha integrated buyer.\n\n2) Update the 'TEMPLATE_API_TOKEN' and then update the 'TEMPLATE_PLACEMENT_ID' values in the 'Ping Data' and 'Post Data' fields with the values provided by Media Alpha.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_token",
                property_name: "Media Alpha API Token",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_API_TOKEN"
            },
            {
                property_id: "placement_id",
                property_name: "Media Alpha Placement ID",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_PLACEMENT_ID"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    lead_api_px_ping_post: {
        fields: {
            output_tag_prefix: 'leads_api_px_12345',

            ping_url: 'https://leadapi.px.com/api/call/ping',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","Accept":"application/json"}',
            ping_data: '{"ApiToken":"TEMPLATE_API_TOKEN","Vertical":"TEMPLATE_VERTICAL","SubId":"TEMPLATE_SUB_ID","OfferId":"TEMPLATE_OFFER_ID","OriginalUrl":"Not applicable","ContactData":{"PhoneNumber":"[caller_number]","ZipCode":"[caller_zip]"}}',
            ping_output_map: '{"PingOutputMap":{"ping_TransactionId":"TransactionId","ping_Success":"Success","bid":"Payout","ping_Sold":"Sold"}}',

            post_condition_key: 'ping_Success',
            post_condition_operator: 'is_equal',
            post_condition_value: 'true',

            post_url: 'https://leadapi.px.com/api/call/post',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json","Accept":"application/json"}',
            post_data: '{"TransactionId":"<podd_start>ping_TransactionId<podd_end>","ApiToken":"TEMPLATE_API_TOKEN","Vertical":"TEMPLATE_VERTICAL","SubId":"TEMPLATE_SUB_ID","OfferId":"TEMPLATE_OFFER_ID","OriginalUrl":"Not applicable","ContactData":{"ZipCode":"[caller_zip]","PhoneNumber":"[caller_number]"}}',
            post_output_map: '{"PostOutputMap":{"post_TransactionId":"TransactionId","post_Success":"Success","post_payout":"Payout","post_Sold":"Sold"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria. \n\n3) For the 'Seconds Tag' field, set the value to a hardcoded value to match with your affiliate partner agreement.\n\n4) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n5) Scroll to the 'Tag List' section, then press the 'wizard' button.\n\n6) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_bid' as the key, \n'greater than' as the operator, \n'0' as the value.\n\n7) Press 'add' on the tag wizard.\n\n8) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Lead PX API to request for a potential conversion bid. If the Lead PX request returns a valid conversion bid, Retreaver will open the Lead PX integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Lead PX integrated buyer.\n\n2) Update the 'Ping Data' and 'Post Data' fields including:\nTEMPLATE_API_TOKEN\nTEMPLATE_VERTICAL\nTEMPLATE_SUB_ID\nTEMPLATE_OFFER_ID\nMake sure to match with the instructions provided by Lead PX.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_token",
                property_name: "Lead PX API Token",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_API_TOKEN"
            },
            {
                property_id: "vertical",
                property_name: "Lead PX Vertical",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_VERTICAL"
            },
            {
                property_id: "sub_id",
                property_name: "Lead PX Sub ID",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_SUB_ID"
            },
            {
                property_id: "offer_id",
                property_name: "Lead PX Offer ID",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_OFFER_ID"
            }

        ],
        template_required_buyer_tags: [
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    apolloi_leads_ping: {
        fields: {
            output_tag_prefix: 'apollo_12345',

            ping_url: 'https://health.apolloileads.com/calls/post/health/TEMPLATE_SOURCE.json',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","Authorization":"Basic TEMPLATE_AUTHORIZATION_TOKEN"}',
            ping_data: '{"telephone":"[nanp_caller_number]","lead_type":"I"}',
            ping_output_map: '{"PingOutputMap":{"bid":"payout","number":"destination_phone_number","timer":"billable_duration","transaction_id":"transaction_id","message":"message"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the ApolloiLeads API to request for a potential conversion bid. If the ApolloiLeads request returns a valid conversion bid, Retreaver will open the ApolloiLeads integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the ApolloiLeads integrated buyer.\n\n2) Update the 'Ping Url's 'TEMPLATE_SOURCE' field using the instructions provided by ApolloiLeads.\n\n3) Update the 'Ping Header's 'TEMPLATE_AUTHORIZATION_TOKEN' with the value provided by ApolloiLeads.\n\n4) Update the 'Ping Data' lead_type field, using 'I' for health, or 'S' for medicare verticals.\n\n5) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_url",
                property_name: "Apollo API URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://health.apolloileads.com/calls/post/health/TEMPLATE_SOURCE.json"
            },
            {
                property_id: "authorization_token",
                property_name: "Apollo Authorization Token",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_AUTHORIZATION_TOKEN"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    zoho_data_post: {
        fields: {
            output_tag_prefix: 'zoho_12345',

            ping_url: 'https://connect.zoho.com/function/api/TEMPLATE_USER_ID/TEMPLATE_USER_PROJECT?zapikey=TEMPLATE_ZAPIKEY',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"First_Name":"[first_name]","Last_Name":"[last_name]","Phone":"[nanp_caller_number]","Email":"[email]","City":"[caller_city]","State":"[caller_state]","Zip_Code":"[caller_zip]","Currently_Covered":"yes","Lead_Source":"TEMPLATE_SOURCE","Lead_Type":"TEMPLATE_LEAD_TYPE"}',
            ping_output_map: '{"PingOutputMap":{}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '4'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Selected: When a buyer is selected'.\n\n2) Use the tag wizard to apply a buyer ID tag on the webhook 'matches' field, this ensures that this webhook only triggers when a specific buyer is selected."
        },
        template_summary: {
            template_summary_text: "This webhook will post any listed and available caller data fields over to Zoho's database if the caller is routed to a specified buyer."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Zoho integrated buyer.\n\n2) Update the 'Ping Url' using the instructions provided by Zoho, be sure to replace the TEMPLATE_USER_ID, TEMPLATE_USER_PROJECT and TEMPLATE_ZAPIKEY values with the values provided by Zoho.\n\n3) Update the 'Ping Data' fields to include any required values you wish to pass. Make sure you also update the 'TEMPLATE_SOURCE' and 'TEMPLATE_LEAD_TYPE' fields to match with the instructions provided by Zoho.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_url",
                property_name: "Zoho API URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://connect.zoho.com/function/api/TEMPLATE_USER_ID/TEMPLATE_USER_PROJECT"
            },
            {
                property_id: "zapi_key",
                property_name: "Zoho ZAPI Key",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_ZAPIKEY"
            },
            {
                property_id: "lead_source",
                property_name: "Zoho Lead Source",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_SOURCE"
            },
            {
                property_id: "lead_type",
                property_name: "Zoho Lead Type",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_LEAD_TYPE"
            }
        ]
    },
    avenge_digital_ping_post: {
        fields: {
            output_tag_prefix: 'avenge_digital_12345',

            ping_url: 'https://www.avengehub.com/Api/PingV1?apiKey=TEMPLATE_API_KEY',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"CampaignId":TEMPLATE_CAMPAIGN_ID,"ZipCode":"[caller_zip]","CallerPhoneNumber":"[nanp_caller_number]","ExternalId":"[call_uuid]","CustomerData":{"FirstName":"Unavailable","LastName":"Unavailable","Address":"Unavailable","City":"[caller_city]","ZipCode":"[caller_zip]","State":"[caller_state]","Email":"Unavailable","Birthdate":"1955-12-30","ContactPhoneNumber":"[nanp_caller_number]","LifeInsurance":{}}}',
            ping_output_map: '{"PingOutputMap":{"ping_id":"Id","number":"PhoneNumber","bid":"Payout.Amount","timer":"Payout.QualifiedDurationInSeconds"}}',

            post_condition_key: 'bid',
            post_condition_operator: 'is_greater_than',
            post_condition_value: '0',

            post_url: 'https://www.avengehub.com/Api/PostV1?apiKey=TEMPLATE_API_KEY',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json"}',
            post_data: '{"Id":"<podd_start>ping_id<podd_end>","CampaignId":TEMPLATE_CAMPAIGN_ID,"ZipCode":"[caller_zip]","CallerPhoneNumber":"[nanp_caller_number]","ExternalId":"[call_uuid]","CustomerData":{"FirstName":"Unavailable","LastName":"Unavailable","Address":"Unavailable","City":"[caller_city]","ZipCode":"[caller_zip]","State":"[caller_state]","Email":"Unavailable","Birthdate":"1955-12-30","ContactPhoneNumber":"[nanp_caller_number]","LifeInsurance":{}}}',
            post_output_map: '{"PostOutputMap":{"accepted":"IsAccepted"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Tag the buyer with a boolean tag value of 'OUTPUT_TAG_PREFIX_accepted = true'.\n\n7) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Avenge Digital API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Avenge Digital request returns a valid transfer number, Retreaver will open the Avenge Digital integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Avenge Digital integrated buyer.\n\n2) Update the 'TEMPLATE_API_KEY' on both the 'Ping URL' and 'Post URL' fields, and then update the 'TEMPLATE_CAMPAIGN_ID' values in the 'Ping Data' and 'Post Data' fields with the values provided by Avenge Digital.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_key",
                property_name: "Avenge Digital API Key",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            },
            {
                property_id: "campaign_id",
                property_name: "Avenge Digital Campaign ID",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_ID"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    blacklist_alliance: {
        fields: {
            output_tag_prefix: 'blacklist_alliance',

            ping_url: 'https://api.blacklistalliance.net/standard/api/v1/Lookup/key/TEMPLATE_API_KEY/response/json/phone/[nanp_caller_number]',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"message":"message"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a boolean tag type, enter the following: \n'OUTPUT_TAG_PREFIX_message' as the key, \n'equals' as the operator, \n'Good' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Blacklist Alliance API to request a boolean 'message' response value representing the eligibility of the caller. If the 'message' response value is 'Good', Retreaver will open the Blacklist Alliance integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Ping URL' field to match with the instructions provided by Blacklist Alliance, replace the 'TEMPLATE_API_KEY' in the URL.\n\n2) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "api_key",
                property_name: "Blacklist Alliance API Key",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            }
        ]
    },
    dig_thrive_ping: {
        fields: {
            output_tag_prefix: 'digthrive_12345',

            ping_url: 'https://in.digthrive.com/dig/feeddata/add?uid=TEMPLATE_UID&phone1=[nanp_caller_number]',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"bid":"price","timer":"duration","number":"phoneNumber"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the DigThrive API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the DigThrive request returns a valid transfer number, Retreaver will open the DigThrive integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the DigThrive integrated buyer.\n\n2) Update the 'TEMPLATE_UID' on the 'Ping URL' field with the value provided by DigThrive.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_UID",
                property_name: "DigThrive API UID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_UID"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    go_high_level_data_post: {
        fields: {
            output_tag_prefix: 'gohighlevel_12345',

            ping_url: 'https://rest.gohighlevel.com/v1/contacts/',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","Authorization":"Bearer TEMPLATE_BEARER_TOKEN"}',
            ping_data: '{"firstName":"[TEMPLATE_FIRST_NAME]","lastName":"[TEMPLATE_LAST_NAME]","phone":"[nanp_caller_number]","dateOfBirth":"[TEMPLATE_DOB]","city":"[caller_city]","state":"[caller_state]","postalCode":"[caller_zip]"}',
            ping_output_map: '{"PingOutputMap":{"contact_id":"contact.id"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '4'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Selected: When a buyer is selected'.\n\n2) Use the tag wizard to apply a buyer ID tag on the webhook 'matches' field, this ensures that this webhook only triggers when a specific buyer is selected.\n\n3) Update your campaign to apply your webhook changes."
        },
        template_summary: {
            template_summary_text: "This webhook will post any listed and available caller data fields over to GoHighLevel's database if the caller is routed to a specified buyer."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the GoHighLevel integrated buyer.\n\n2) Update the 'Ping Header' 'TEMPLATE_BEARER_TOKEN' field using the instructions provided by GoHighLevel.\n\n3) Update the 'Ping Data' fields to include any required values you wish to pass. Make sure you update any fields with a 'TEMPLATE' prefix to match with the tag key you are storing the caller details under.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "bearer_token",
                property_name: "Go High Level Bearer Token",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_BEARER_TOKEN"
            },
            {
                property_id: "first_name",
                property_name: "Caller First Name Value",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "[TEMPLATE_FIRST_NAME]"
            },
            {
                property_id: "last_name",
                property_name: "Caller Last Name Value",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "[TEMPLATE_LAST_NAME]"
            },
            {
                property_id: "dob",
                property_name: "Caller Date Of Birth Value",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "[TEMPLATE_DOB]"
            },
        ]
    },
    health_markets_ping_post: {
        fields: {
            output_tag_prefix: 'health_markets_12345',

            ping_url: 'https://lc-api.healthmarkets.com/api/caller/lead/ping',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","Authorization-Token":"TEMPLATE_AUTHORIZATION_TOKEN"}',
            ping_data: '{"CallerId":"[nanp_caller_number]","VendorCode":"TEMPLATE_VENDORCODE","CampaignCode":"TEMPLATE_CAMPAIGNCODE","State":"[caller_state]","Zip":"[caller_zip]"}',
            ping_output_map: '{"PingOutputMap":{"pingid":"PingId","bid":"Bid"}}',

            post_condition_key: 'bid',
            post_condition_operator: 'is_greater_than',
            post_condition_value: '0',

            post_url: 'https://lc-api.healthmarkets.com/api/caller/lead/post',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json","Authorization-Token":"TEMPLATE_AUTHORIZATION_TOKEN"}',
            post_data: '{"VendorCode":"TEMPLATE_VENDORCODE","CampaignCode":"TEMPLATE_CAMPAIGNCODE","PingId":"<podd_start>pingid<podd_end>","PrimaryPhone":"[nanp_caller_number]","Address":{"State":"[caller_state]","Zip":"[caller_zip]"}}',
            post_output_map: '{"PostOutputMap":{"PostId":"PostId","LeadId":"LeadId","HasError":"HasError"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria. \n\n3) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n4) Tag the buyer with a numerical tag value of 'OUTPUT_TAG_PREFIX_bid 'is greater than' '0', this will prevent routing to the buyer if no bid was returned.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Health Markets API to request for a potential conversion bid. If the Health Markets request returns a valid bid, Retreaver will open the Health Markets integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Health Markets integrated buyer.\n\n2) Update the 'TEMPLATE_AUTHORIZATION_TOKEN' on both the 'Ping Headers' and 'Post Header' fields.\n\n3) Update the 'TEMPLATE_VENDORCODE' and 'TEMPLATE_CAMPAIGNCODE' values in the 'Ping Data' and 'Post Data' fields with the values provided by Health Markets.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "authorization_token",
                property_name: "Health Markets Authorization Token",
                fields_to_replace: [
                    "ping_headers",
                    "post_headers"
                ],
                replacement_token: "TEMPLATE_AUTHORIZATION_TOKEN"
            },
            {
                property_id: "vendor_code",
                property_name: "Health Markets Vendor Code",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_VENDORCODE"
            },
            {
                property_id: "campaign_code",
                property_name: "Health Markets Campaign Code",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_CAMPAIGNCODE"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    national_debt_relief_data_post: {
        fields: {
            output_tag_prefix: 'national_debt_relief_12345',

            ping_url: 'https://apply.nationaldebtrelief.com/services/apexrest/affiliates/TEMPLATE_AFFILIATE_CODE/lead',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"firstname":"[TEMPLATE_FIRSTNAME]","lastname":"[TEMPLATE_LASTNAME]","email":"[TEMPLATE_EMAIL]","phone":"[nanp_caller_number]","address1":"[TEMPLATE_ADDRESS]","city":"[caller_city]","state":"[caller_state]","zipcode":"[caller_zip]","totaldebtamount":"[TEMPLATE_DEBT_AMOUNT]"}',
            ping_output_map: '{"PingOutputMap":{}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '4'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Selected: When a buyer is selected'.\n\n2) Use the tag wizard to apply a buyer ID tag on the webhook 'matches' field, this ensures that this webhook only triggers when a specific buyer is selected.\n\n3) Update your campaign to apply your webhook changes."
        },
        template_summary: {
            template_summary_text: "This webhook will post any listed and available caller data fields over to National Debt Relief's database if the caller is routed to a specified buyer."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the National Debt Relief integrated buyer.\n\n2) Update the 'Ping Url' 'TEMPLATE_AFFILIATE_CODE' field using the instructions provided by National Debt Relief.\n\n3) Update the 'Ping Data' fields to include any required values you wish to pass. Make sure to update any replacement token fields containing the 'TEMPLATE' placeholder with the Retreaver tag key you are using to store those values.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_url",
                property_name: "NDR API Ping URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://apply.nationaldebtrelief.com/services/apexrest/affiliates/TEMPLATE_AFFILIATE_CODE/lead"
            },
            {
                property_id: "first_name",
                property_name: "Caller First Name Value",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "[TEMPLATE_FIRSTNAME]"
            },
            {
                property_id: "last_name",
                property_name: "Caller Last Name Value",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "[TEMPLATE_LASTNAME]"
            },
            {
                property_id: "email",
                property_name: "Caller Email Value",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "[TEMPLATE_EMAIL]"
            },
            {
                property_id: "address",
                property_name: "Caller Address Value",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "[TEMPLATE_ADDRESS]"
            },
            {
                property_id: "debt_amount",
                property_name: "Caller Debt Amount Value",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "[TEMPLATE_DEBT_AMOUNT]"
            },
        ]
    },
    phonexa_ping: {
        fields: {
            output_tag_prefix: 'phonexa_12345',

            ping_url: 'https://TEMPLATE_URL_PREFIX.phonexa.com/lead/?apiID=TEMPLATE_ID&apiPassword=TEMPLATE_PASSWORD&productId=TEMPLATE_PRODUCT_ID&price=0&firstName=[TEMPLATE_FN]&lastName=[TEMPLATE_LN]&email=[TEMPLATE_EMAIL]&zip=[caller_zip]&dob=[TEMPLATE_DOB]&state=[caller_state]&phoneNumber=[nanp_caller_number]',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"bid":"price","status_text":"status_text"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria. \n\n3) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n4) For the buyer tag list, apply the following numeric tag filter: 'OUTPUT_TAG_PREFIX_bid' 'greater than' '0', this will open the buyer for routing only when a bid is received.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Phonexa API to request for a potential conversion bid. If the Phonexa request returns a valid bid, Retreaver will open the Phonexa integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Phonexa integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Phonexa, start by updating the following fields: 'TEMPLATE_ID', 'TEMPLATE_PASSWORD', 'TEMPLATE_PRODUCT_ID'.\n\n3) Update the remaining fields in the 'Ping URL' prefixed with 'TEMPLATE' with the replacement tag key tokens you are using to store those values, including 'TEMPLATE_FN', 'TEMPLATE_LN', 'TEMPLATE_EMAIL' and 'TEMPLATE_DOB'.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_url",
                property_name: "Phonexa API URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://TEMPLATE_URL_PREFIX.phonexa.com/lead/"
            },
            {
                property_id: "api_id",
                property_name: "Phonexa API ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_ID"
            },
            {
                property_id: "api_password",
                property_name: "Phonexa API Password",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_PASSWORD"
            },
            {
                property_id: "product_id",
                property_name: "Phonexa Product ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_PRODUCT_ID"
            },
            {
                property_id: "first_name",
                property_name: "Caller First Name Value",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "[TEMPLATE_FN]"
            },
            {
                property_id: "last_name",
                property_name: "Caller Last Name Value",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "[TEMPLATE_LN]"
            },
            {
                property_id: "email",
                property_name: "Caller Email Value",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "[TEMPLATE_EMAIL]"
            },
            {
                property_id: "dob",
                property_name: "Caller Date Of Birth Value",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "[TEMPLATE_DOB]"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    visiqua_ping: {
        fields: {
            output_tag_prefix: 'visiqua_12345',

            ping_url: 'https://api.callstoconvert.com/api/callAPI',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"campaign_token":"TEMPLATE_CAMPAIGN_TOKEN","caller_id":"[nanp_caller_number]","zip_code":"[caller_zip]"}',
            ping_output_map: '{"PingOutputMap":{"bid":"payout","timer":"duration","number":"DID"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Visiqua API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Visiqua request returns a valid transfer number, Retreaver will open the Visiqua integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Visiqua integrated buyer.\n\n2) Update the 'Ping Data' 'TEMPLATE_CAMPAIGN_TOKEN' field to match with the instructions provided by Visiqua.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "campaign_token",
                property_name: "Visiqua Campaign Token",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_TOKEN"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    quote_wizard_health_ping: {
        fields: {
            output_tag_prefix: 'quotewizard_12345',

            ping_url: 'https://api.quotewizard.com/calls/v1/InboundPingPartialLead',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"campaignId":TEMPLATE_CAMPAIGN_ID,"Apikey":"TEMPLATE_API_KEY","data":{"quoteRequest":{"item":{"contact":{"zipCode":"[caller_zip]"},"healthInsuranceQuoteRequest":{"person":{"birthDate":"[TEMPLATE_DOB-YYYY-MM-DD-FORMAT]"}}}}}}',
            ping_output_map: '{"PingOutputMap":{"number":"phoneNumber","bid":"bid","timer":"payableThreshold"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the QuoteWizard Health API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the QuoteWizard request returns a valid transfer number, Retreaver will open the QuoteWizard integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the QuoteWizard integrated buyer.\n\n2) Update the 'Ping Data' 'TEMPLATE_CAMPAIGN_ID' and 'TEMPLATE_API_KEY' fields to match with the instructions provided by QuoteWizard.\n\n3) For the Caller DOB value, provide a hardcoded DOB or use a tag replacement token if you are collecting that value.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "campaign_id",
                property_name: "QuoteWizard Campaign ID",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_ID"
            },
            {
                property_id: "api_key",
                property_name: "QuoteWizard API Key",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            },
            {
                property_id: "dob",
                property_name: "Caller Date Of Birth Value",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "[TEMPLATE_DOB-YYYY-MM-DD-FORMAT]"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    quote_wizard_auto_ping: {
        fields: {
            output_tag_prefix: 'quotewizard_12345',

            ping_url: 'https://api.quotewizard.com/calls/v1/InboundPingPartialLead',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"campaignId":TEMPLATE_CAMPAIGN_ID,"Apikey":"TEMPLATE_API_KEY","data":{"quoteRequest":{"item":{"contact":{"zipCode":"[caller_zip]"},"autoInsuranceQuoteRequest":{"insuranceProfile":{"currentPolicy":{"insuranceCompany":{"CompanyName":"UNKNOWN"}}}}}}}}',
            ping_output_map: '{"PingOutputMap":{"number":"phoneNumber","bid":"bid","timer":"payableThreshold"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the QuoteWizard Auto API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the QuoteWizard request returns a valid transfer number, Retreaver will open the QuoteWizard integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the QuoteWizard integrated buyer.\n\n2) Update the 'Ping Data' 'TEMPLATE_CAMPAIGN_ID' and 'TEMPLATE_API_KEY' fields to match with the instructions provided by QuoteWizard.\n\n3) For the Insurance Company Name value, enter 'UNKNOWN' for uninsured, or OTHER if insured.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "campaign_id",
                property_name: "QuoteWizard Campaign ID",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_ID"
            },
            {
                property_id: "api_key",
                property_name: "QuoteWizard API Key",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            },
            {
                property_id: "insurance_company",
                property_name: "Caller Insurance Company Name",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "UNKNOWN"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    wisdom_co_ping: {
        fields: {
            output_tag_prefix: 'wisdomco_12345',

            ping_url: 'https://api-gw.thewisdomco.com/retreaver/publishers/pre-ping?publisherUuid=TEMPLATE_PUBLISHER_UUID&publisherSlug=TEMPLATE_PUBLISHER_SLUG&publisherPostbackKey=TEMPLATE_PUBLISHER_POSTBACK_KEY&campaignSlug=TEMPLATE_CAMPAIGN_SLUG&callerId=[nanp_caller_number]&publisherPhone=[called_number]&zipCode=[caller_zip]',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"bid":"bid.amount","timer":"bid.duration","allowed":"allowed"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria. \n\n3) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n4) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n5) Scroll to the 'Tag List' section, then press the 'wizard' button.\n\n6) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_bid' as the key, \n'greater than' as the operator, \n'0' as the value.\n\n7) Using a text tag type, enter the following: \n'OUTPUT_TAG_PREFIX_allowed' as the key, \n'equals' as the operator, \n'true' as the value.\n\n8) Press 'add' on the tag wizard then press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the WisdomCo API to request for a potential conversion bid and conversion timer. If the WisdomCo request returns a valid bid, Retreaver will open the WisdomCo integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the WisdomCo integrated buyer.\n\n2) Update the 'Ping Url' 'TEMPLATE_PUBLISHER_UUID', 'TEMPLATE_PUBLISHER_SLUG', 'TEMPLATE_PUBLISHER_POSTBACK_KEY' and 'TEMPLATE_CAMPAIGN_SLUG' fields to match with the instructions provided by WisdomCo.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "publisher_uuid",
                property_name: "WisdomCo Publisher UUID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_PUBLISHER_UUID"
            },
            {
                property_id: "publisher_slug",
                property_name: "WisdomCo Publisher Slug",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_PUBLISHER_SLUG"
            },
            {
                property_id: "publisher_postback_key",
                property_name: "WisdomCo Publisher Postback Key",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_PUBLISHER_POSTBACK_KEY"
            },
            {
                property_id: "campaign_slug",
                property_name: "WisdomCo Campaign Slug",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_SLUG"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            },
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_allowed",
                "operator": "==",
                "value": "true"
            }
        ]
    },
    americas_health_center_availability: {
        fields: {
            output_tag_prefix: 'ahc_12345',

            ping_url: 'https://manage.americashealthcenter.org/api/AgentStatus?ApiKey=TEMPLATE_API_KEY',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"agents_waiting":"agents_waiting"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_agents_waiting' as the key, \n'greater than' as the operator, \n'0' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Americas Health Center Agent Availability API to request a numeric 'agents_waiting' response value representing the number of agents available to take a call. If the 'agents_waiting' response value is above 0, Retreaver will open the Americas Health Center integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Americas Health Center integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Americas Health Center, including the TEMPLATE_API_KEY parameter.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_key",
                property_name: "Americas Health Center API Key",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_agents_waiting",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    call_tools_availability: {
        fields: {
            output_tag_prefix: 'call_tools_12345',

            ping_url: 'https://west-4.calltools.io/api/agentstatuses/?queue=TEMPLATE_QUEUE_VALUE',
            ping_method: 'GET',
            ping_headers: '{"Authorization":"Token TEMPLATE_TOKEN"}',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"count":"count"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_count' as the key, \n'greater than' as the operator, \n'0' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Call Tools Agent Availability API to request a numeric 'count' response value representing the number of agents ready to take a call. If the 'count' response value is above 0, Retreaver will open the Call Tools integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Call Tools integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Call Tools, including the TEMPLATE_QUEUE_VALUE parameter.\n\n3) Update the 'Ping Header' field to match with the instructions provided by Call Tools, including the TEMPLATE_TOKEN authorization token.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "queue",
                property_name: "CallTools Queue Value",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_QUEUE_VALUE"
            },
            {
                property_id: "authorization_token",
                property_name: "CallTools Authorization Token",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_TOKEN"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_count",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    free_voice_availability: {
        fields: {
            output_tag_prefix: 'free_voice_12345',

            ping_url: 'https://TEMPLATE_URL.freevoicepbx.com/api/agentsavailapi/?api_key=TEMPLATE_API_KEY',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"available":"data.available"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_available' as the key, \n'greater than' as the operator, \n'0' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Free Voice Agent Availability API to request a numeric 'available' response value representing the number of agents ready to take a call. If the 'available' response value is above 0, Retreaver will open the Free Voice integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Free Voice integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Free Voice, including the TEMPLATE_API_KEY parameter.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_url",
                property_name: "FreeVoice API URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://TEMPLATE_URL.freevoicepbx.com/api/agentsavailapi/"
            },
            {
                property_id: "api_key",
                property_name: "FreeVoice API Key",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_available",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    retreaver_rtb_ping: {
        fields: {
            output_tag_prefix: 'retreaver_rtb_12345',

            ping_url: 'https://rtb.retreaver.com/rtbs.json?caller_number=[nanp_caller_number]&key=TEMPLATE_RTB_KEY&publisher_id=TEMPLATE_PUBLISHER_ID',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"number":"inbound_number","bid":"retreaver_payout","timer":"retreaver_seconds"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Retreaver RTB API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Retreaver RTB request returns a valid transfer number, Retreaver will open the Retreaver RTB integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Retreaver RTB integrated buyer.\n\n2) Update the 'Ping URL' with the link provided by the Retreaver RTB provider, be sure to include any URL parameters & tag tokens you'd like to forward downstream as well.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "rtb_link",
                property_name: "Retreaver RTB Link",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://rtb.retreaver.com/rtbs.json?caller_number=[nanp_caller_number]&key=TEMPLATE_RTB_KEY&publisher_id=TEMPLATE_PUBLISHER_ID"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    d2m_ping_post: {
        fields: {
            output_tag_prefix: 'd2m_12345',

            ping_url: 'https://offers.d2m-api.com/v1/offers/search?FsearchType=broad&category=TEMPLATE_CATEGORY&subCategory=TEMPLATE_SUBCATEGORY&keyword=&brandName=&channel=&radius=&city=[caller_city]&state=[caller_state]&limit=10',
            ping_method: 'GET',
            ping_headers: '{"x-api-key":"TEMPLATE_API_KEY"}',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"id":"0.id","timer":"0.billableDuration","bid":"0.advertiserPayout"}}',

            post_condition_key: 'bid',
            post_condition_operator: 'is_greater_than',
            post_condition_value: '0',

            post_url: 'https://offers.d2m-api.com/v1/offers/callback?request_id=<podd_start>id<podd_end>',
            post_method: 'POST',
            post_headers: '{"Content-Type": "application/x-www-form-urlencoded","x-api-key":"TEMPLATE_API_KEY"}',
            post_data: '',
            post_output_map: '{"PostOutputMap":{"number":"number"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the D2M API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the D2M request returns a valid transfer number, Retreaver will open the D2M integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the D2M integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by D2M, update the 'TEMPLATE_CATEGORY' and then update the 'TEMPLATE_SUBCATEGORY' url parameters with the values provided by D2M.\n\n3) Update the ping and post header fields to match with the instructions provided by D2M, update the 'TEMPLATE_API_KEY' with the value provided by D2M.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "category",
                property_name: "D2M Category",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_CATEGORY"
            },
            {
                property_id: "subcategory",
                property_name: "D2M Subcategory",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_SUBCATEGORY"
            },
            {
                property_id: "api_key",
                property_name: "D2M X-API-Key",
                fields_to_replace: [
                    "ping_headers",
                    "post_headers"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    elocal_ping: {
        fields: {
            output_tag_prefix: 'elocal_12345',

            ping_url: 'http://api.elocal.com/call/ping',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"ping": {"zip_code":"[caller_zip]", "need_id": "TEMPLATE_NEED_ID", "key":"TEMPLATE_KEY"}}',
            ping_output_map: '{"PingOutputMap":{"status":"response.status","number":"response.phone_number","bid":"response.price","timer":"response.billable_duration"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the ELocal API to request for a potential conversion bid and dynamic transfer number. If the ELocal request returns a valid transfer number, Retreaver will open the ELocal integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the ELocal integrated buyer.\n\n2) Update the 'Ping Data' 'TEMPLATE_NEED_ID' and 'TEMPLATE_KEY' fields to match with the instructions provided by the ELocal provider.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "need_id",
                property_name: "ELocal Need ID",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_NEED_ID"
            },
            {
                property_id: "key",
                property_name: "ELocal API Key",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_KEY"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    easy_health_ping: {
        fields: {
            output_tag_prefix: 'easy_health_12345',

            ping_url: 'https://availability.easyhealth.dev/api/ping',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"accessToken":"TEMPLATE_ACCESS_TOKEN","phone":"[nanp_caller_number]"}',
            ping_output_map: '{"PingOutputMap":{"bid":"bid","timer":"billableDuration","number":"did","bidid":"bidid"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Easy Health API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Easy Health request returns a valid transfer number, Retreaver will open the Easy Health integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Easy Health integrated buyer.\n\n2) Update the 'Ping Data' 'TEMPLATE_ACCESS_TOKEN' field to match with the instructions provided by the Easy Health provider.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "access_token",
                property_name: "EasyHealth Access Token",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_ACCESS_TOKEN"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    archenia_ping: {
        fields: {
            output_tag_prefix: 'archenia_12345',

            ping_url: 'https://services.archenia.io/mcm/listings?partnerId=TEMPLATE_PARTNER_ID&searchType=TEMPLATE_SEARCH_TYPE&searchTerm=TEMPLATE_SEARCH_TERM&city=[caller_city]&state=[caller_state]',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"number":"0.callTrackingNumber","timer":"0.billableDuration","bid":"0.publisherPayout","business_name":"0.businessName"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Archenia API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Archenia request returns a valid transfer number, Retreaver will open the Archenia integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Archenia integrated buyer.\n\n2) Update the following 'Ping URL' parameters: 'TEMPLATE_PARTNER_ID', 'TEMPLATE_SEARCH_TYPE', 'TEMPLATE_SEARCH_TERM' to match with the instructions provided by the Archenia provider.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "partner_id",
                property_name: "Archenia Partner ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_PARTNER_ID"
            },
            {
                property_id: "search_type",
                property_name: "Archenia Search Type",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_SEARCH_TYPE"
            },
            {
                property_id: "search_term",
                property_name: "Archenia Search Term",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_SEARCH_TERM"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    marchex_ping: {
        fields: {
            output_tag_prefix: 'marchex_12345',

            ping_url: 'https://services.marchex.com/mcm/listings?partnerId=TEMPLATE_PARTNER_ID&searchType=TEMPLATE_SEARCH_TYPE&searchTerm=TEMPLATE_SEARCH_TERM&radius=50&zip=[caller_zip]',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"number":"Response[0].callTrackingNumber","business_name":"Response[0].businessName","timer":"Response[0].billableDuration","bid":"Response[0].publisherPayout"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Marchex API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Marchex request returns a valid transfer number, Retreaver will open the Marchex integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Marchex integrated buyer.\n\n2) Update the following 'Ping URL' parameters: 'TEMPLATE_PARTNER_ID', 'TEMPLATE_SEARCH_TYPE', 'TEMPLATE_SEARCH_TERM' to match with the instructions provided by the Marchex provider.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "partner_id",
                property_name: "Marchex Partner ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_PARTNER_ID"
            },
            {
                property_id: "search_type",
                property_name: "Marchex Search Type",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_SEARCH_TYPE"
            },
            {
                property_id: "search_term",
                property_name: "Marchex Search Term",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_SEARCH_TERM"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    soleo_ping: {
        fields: {
            output_tag_prefix: 'soleo_12345',

            ping_url: 'https://api.soleo.com/sponsored?Category=TEMPLATE_CATEGORY&City=[caller_city]&State=[caller_state]&APIKey=TEMPLATE_API_KEY&MaxSponsoredCount=1&ANI=[nanp_caller_number]',
            ping_method: 'GET',
            ping_headers: '{"Accept":"application/vnd.api.soleo.com-v2%2Bjson"}',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"number":"businesses[0].completionPhoneNumber","timer":"businesses[0].monetizationCritera.criteria","bid":"businesses[0].monetizationCritera.value"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Soleo API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Soleo request returns a valid transfer number, Retreaver will open the Soleo integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Soleo integrated buyer.\n\n2) Update the following 'Ping URL' parameters: 'TEMPLATE_CATEGORY', 'TEMPLATE_API_KEY' to match with the instructions provided by the Soleo provider.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "category",
                property_name: "Soleo Category",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_CATEGORY"
            },
            {
                property_id: "api_key",
                property_name: "Soleo API Key",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    all_calls_availability: {
        fields: {
            output_tag_prefix: 'allcalls_12345',

            ping_url: 'https://allcalls.io/api/agent-status?phone=[nanp_caller_number]&vertical=TEMPLATE_VERTICAL&affiliate_id=TEMPLATE_AFFILIATE_ID&api_key=TEMPLATE_API_KEY',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"online":"online"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a boolean tag type, enter the following: \n'OUTPUT_TAG_PREFIX_online' as the key, \n'equals' as the operator, \n'true' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the All Calls Agent Availability API to request a boolean 'online' response value representing if an agent is available to take a call. If the 'online' response equals 'true', Retreaver will open the All Calls integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the All Calls integrated buyer.\n\n2) Update the following 'Ping URL' parameters: 'TEMPLATE_VERTICAL', 'TEMPLATE_AFFILIATE_ID', 'TEMPLATE_API_KEY' to match with the instructions provided by All Calls.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "vertical",
                property_name: "AllCalls Vertical",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_VERTICAL"
            },
            {
                property_id: "affiliate_id",
                property_name: "AllCalls Affiliate ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_AFFILIATE_ID"
            },
            {
                property_id: "api_key",
                property_name: "AllCalls API Key",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_online",
                "operator": "==",
                "value": "true"
            },
        ]
    },
    benefit_align_availability: {
        fields: {
            output_tag_prefix: 'benefit_align_12345',

            ping_url: 'https://mme.benefitalign.com/v2/cti/external/TEMPLATE_PARTNER_CODE/agentavailability',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","x-api-key":"TEMPLATE_X_API_KEY"}',
            ping_data: '{"eventContext":{"contextMap":{"entries":[{"key":"campaignGroupNumber","value":"TEMPLATE_CAMPAIGN_GROUP_NUMBER"},{"key":"leadVendorName","value":"TEMPLATE_VENDOR_NAME"}]}}}',
            ping_output_map: '{"PingOutputMap":{"availability_value":"contextMap.entries[0].value"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a boolean tag type, enter the following: \n'OUTPUT_TAG_PREFIX_availability_value' as the key, \n'equals' as the operator, \n'true' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Benefit Align Agent Availability API to request a boolean 'availability_value' response value representing if an agent is available to take a call. If the 'availability_value' response equals 'true', Retreaver will open the Benefit Align integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Benefit Align integrated buyer.\n\n2) Update the following 'Ping URL' parameter: 'TEMPLATE_PARTNER_CODE', then update the following 'Ping Header' parameter: 'TEMPLATE_X_API_KEY', lastly update the following 'Ping Data' parameter: 'TEMPLATE_CAMPAIGN_GROUP_NUMBER' and 'TEMPLATE_VENDOR_NAME' to match with the instructions provided by Benefit Align.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_url",
                property_name: "BenefitAlign API URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://mme.benefitalign.com/v2/cti/external/TEMPLATE_PARTNER_CODE/agentavailability"
            },
            {
                property_id: "x_api_key",
                property_name: "BenefitAlign X-API-KEY",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_X_API_KEY"
            },
            {
                property_id: "campaign_group_number",
                property_name: "BenefitAlign Campaign Group Number",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_GROUP_NUMBER"
            },
            {
                property_id: "vendor_name",
                property_name: "BenefitAlign Vendor Name",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_VENDOR_NAME"
            },
        ],
        template_required_buyer_tags: [
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_availability_value",
                "operator": "==",
                "value": "true"
            },
        ]
    },
    hive_hq_availability: {
        fields: {
            output_tag_prefix: 'hivehq_availability_12345',

            ping_url: 'https://buyers.ps-api.hivehq.co/v1/availability',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"key":"TEMPLATE_KEY","phone":"[nanp_caller_number]","zip":"[caller_zip]"}',
            ping_output_map: '{"PingOutputMap":{"message":"message","number":"data.reservation_number"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Hive HQ Agent Availability API to request a dynamic 'reservation_number' representing if an agent is available to take a call. If the 'reservation_number' response is present, Retreaver will route the call using the 'reservation_number' for the Hive HQ integrated buyer."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Hive HQ integrated buyer.\n\n2) Update the following 'Ping Data' parameter: 'TEMPLATE_KEY' to match with the instructions provided by Hive HQ.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_key",
                property_name: "HiveHQ API Key",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_KEY"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            }
        ]
    },
    winning_availability: {
        fields: {
            output_tag_prefix: 'winning_12345',

            ping_url: 'https://www.winning.today/posting/template-availability-ping',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"available_agents":"template_available_agents"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a boolean tag type, enter the following: \n'OUTPUT_TAG_PREFIX_available_agents' as the key, \n'is_greater_than' as the operator, \n'0' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Winning Agent Availability API to request a numeric 'available_agents' response value representing if an agent is available to take a call. If the 'available_agents' response is greater than '0', Retreaver will open the Winning integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Winning integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Winning.\n\n3) Replace the 'template_available_agents' response key in the 'Ping Output Map' field, which represents the JSON key we expect to access the agent availability value from the response of the API.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_url",
                property_name: "Winning URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://www.winning.today/posting/template-availability-ping"
            },
            {
                property_id: "response_key",
                property_name: "Winning Response Key",
                fields_to_replace: [
                    "ping_output_map"
                ],
                replacement_token: "template_available_agents"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_available_agents",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    chasedata_availability: {
        fields: {
            output_tag_prefix: 'chasedata_12345',

            ping_url: 'https://api.chasedatacorp.com/HttpImport/CallOperations.php?token=TEMPLATE_TOKEN&accid=TEMPLATE_ACCID&Action=AvailableInboundAgents&DID=TEMPLATE_DID',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"available_agents":"AvailableInboundAgents"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a boolean tag type, enter the following: \n'OUTPUT_TAG_PREFIX_available_agents' as the key, \n'is greater than' as the operator, \n'0' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the ChaseData Agent Availability API to request a numeric 'available_agents' response value representing if an agent is available to take a call. If the 'available_agents' response is greater than '0', Retreaver will open the ChaseData integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the ChaseData integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by ChaseData, update the 'TEMPLATE_TOKEN', 'TEMPLATE_ACCID' and 'TEMPLATE_DID' url parameters.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "token",
                property_name: "ChaseData Token",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_TOKEN"
            },
            {
                property_id: "accid",
                property_name: "ChaseData Accid",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_ACCID"
            },
            {
                property_id: "did",
                property_name: "ChaseData DID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_DID"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_available_agents",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    leadspedia_ping: {
        fields: {
            output_tag_prefix: 'leadspedia_12345',

            ping_url: 'https://TEMPLATE_URL.leadspediatrack.com/call-preping.do?lp_campaign_id=TEMPLATE_CAMPAIGN_ID&lp_campaign_key=TEMPLATE_CAMPAIGN_KEY&caller_id=[nanp_caller_number]&zip_code=[caller_zip]',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"number":"number","timer":"duration","bid":"payout","result":"result","status":"status"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Leadspedia API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Leadspedia request returns a valid transfer number, Retreaver will open the Leadspedia integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Leadspedia integrated buyer.\n\n2) Update the following 'Ping URL' parameters: 'TEMPLATE_CAMPAIGN_ID', 'TEMPLATE_CAMPAIGN_KEY' to match with the instructions provided by the Leadspedia provider.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "leadspedia_ping_url",
                property_name: "Leadspedia Ping URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://TEMPLATE_URL.leadspediatrack.com/call-preping.do"
            },
            {
                property_id: "lp_campaign_id",
                property_name: "Leadspedia Campaign ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_ID"
            },
            {
                property_id: "lp_campaign_key",
                property_name: "Leadspedia Campaign Key",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_KEY"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    marketcall_ping: {
        fields: {
            output_tag_prefix: 'marketcall_12345',

            ping_url: 'https://www.marketcall.com/api/v1/affiliate/offers/9999/bid-requests',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","x-api-key":"TEMPLATE_X_API_KEY"}',
            ping_data: '{"campaign_id": "TEMPLATE_CAMPAIGN_ID","caller_id": "1[nanp_caller_number]","zip_code":"[caller_zip]"}',
            ping_output_map: '{"PingOutputMap":{"number":"data.target_number","timer":"data.terms.duration[0].value","bid":"data.earn.amount"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the MarketCall API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the MarketCall request returns a valid transfer number, Retreaver will open the MarketCall integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the MarketCall integrated buyer.\n\n2) Update the 'Ping URL' field, the 'TEMPLATE_X_API_KEY' in the 'Ping Headers' field and the 'TEMPLATE_CAMPAIGN_ID' in the 'Ping Data' field to match with the instructions provided by the MarketCall provider.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_url",
                property_name: "MarketCall URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://www.marketcall.com/api/v1/affiliate/offers/9999/bid-requests"
            },
            {
                property_id: "api_key",
                property_name: "MarketCall X-API-Key",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_X_API_KEY"
            },
            {
                property_id: "campaign_id",
                property_name: "MarketCall Campaign ID",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_ID"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    everquote_ping: {
        fields: {
            output_tag_prefix: 'everquote_12345',

            ping_url: 'https://calls.everquote.com/ivr_integration/auto',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","Authorization":"Basic%20TEMPLATE_TOKEN"}',
            ping_data: '{"phone_number": "[nanp_caller_number]"}',
            ping_output_map: '{"PingOutputMap":{"timer":"duration_seconds","bid_cents":"bid_cents","bid":"bid_cents"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: 'bid',
            revshare_modifier_percentage: '0.01'
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) This integration does not return a dynamic transfer number, ensure your buyer profile has a defined transfer number present.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Everquote API to request for a potential conversion bid and conversion timer. If the Everquote request returns a valid bid, Retreaver will open the Everquote integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Everquote integrated buyer.\n\n2) Update the 'Ping URL' field, and the 'TEMPLATE_TOKEN' in the 'Ping Headers' field to match with the instructions provided by the Everquote provider.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_url",
                property_name: "Everquote URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://calls.everquote.com/ivr_integration/auto"
            },
            {
                property_id: "authorization_token",
                property_name: "Everquote Authorization Token",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_TOKEN"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    pipedream_ping: {
        fields: {
            output_tag_prefix: 'pipedream_12345',

            ping_url: 'https://template.m.pipedream.net/?pub=TEMPLATE_PUB&phone_number=[nanp_caller_number]&state=[caller_state]&sub1=&sub2=&pub_id=',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"available_inbound_agents":"AvailableInboundAgents","bid":"bid","timer":"duration","number":"did"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Pipedream API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Pipedream request returns a valid transfer number, Retreaver will open the Pipedream integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Pipedream integrated buyer.\n\n2) Update the 'Ping URL' field, and the 'TEMPLATE_PUB' in the 'Ping URL' field to match with the instructions provided by the Pipedream provider.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_url",
                property_name: "Pipedream URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://template.m.pipedream.net/"
            },
            {
                property_id: "pub_id",
                property_name: "Pipedream Publisher Parameter",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_PUB"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    home_appointments_ping_post: {
        fields: {
            output_tag_prefix: 'home_appointments_12345',

            ping_url: 'https://homeappointments.leadportal.com/new_api/api.php?Mode=ping&Format=JSON&Key=TEMPLATE_KEY&API_Action=iprSubmitLead&TYPE=9&SRC=TEMPLATE_SOURCE&ZIP=[caller_zip]&Terminating_Phone=TEMPLATE_TERMINATING_PHONE&Trade=TEMPLATE_TRADE&Origin_Phone=[nanp_caller_number]&Return_Best_Price=1&Return_Min_Duration=1',
            ping_method: 'POST',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"bid":"response.price","timer":"response.min_duration","lead_id":"response.lead_id"}}',

            post_condition_key: 'bid',
            post_condition_operator: 'exists',
            post_condition_value: '0',

            post_url: 'https://homeappointments.leadportal.com/new_api/api.php?Mode=post&Format=JSON&Key=TEMPLATE_KEY&API_Action=iprSubmitLead&TYPE=9&SRC=TEMPLATE_SOURCE&ZIP=[caller_zip]&Terminating_Phone=TEMPLATE_TERMINATING_PHONE&Trade=TEMPLATE_TRADE&Origin_Phone=[nanp_caller_number]&Return_Best_Price=1&Return_Min_Duration=1&Lead_ID=<podd_start>lead_id<podd_end>',
            post_method: 'POST',
            post_headers: '',
            post_data: '',
            post_output_map: '{"PostOutputMap":{"post_status":"response.status"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and ensure the 'Number' matches the terminating phone value: 'TEMPLATE_TERMINATING_PHONE'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Tag your buyer with 'OUTPUT_TAG_PREFIX_post_success:Success' to ensure the buyer is only routed when the post request is accepted.\n\n7) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Home Appointments API to request for a potential conversion bid and conversion timer. If the Home Appointments request returns a valid bid, Retreaver will open the Home Appointments integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Home Appointments integrated buyer.\n\n2) Update the 'Ping URL' and 'Post URL' including: TEMPLATE_KEY, TEMPLATE_SOURCE, TEMPLATE_TERMINATING_PHONE & TEMPLATE_TRADE fields with the values provided by Home Appointments.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_key",
                property_name: "Home Appointments Key",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_KEY"
            },
            {
                property_id: "source",
                property_name: "Home Appointments Source",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_SOURCE"
            },
            {
                property_id: "terminating_phone",
                property_name: "Home Appointments Terminating Phone",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_TERMINATING_PHONE"
            },
            {
                property_id: "trade",
                property_name: "Home Appointments Trade",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_TRADE"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    service_direct_ping_post: {
        fields: {
            output_tag_prefix: 'service_direct_12345',

            ping_url: 'https://api.servicedirect.com/partners/request',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"zip_code": "[caller_zip]","service_category": TEMPLATE_SERVICE_CATEGORY,"sd_api_key":"TEMPLATE_SD_API_KEY"}',
            ping_output_map: '{"PingOutputMap":{"available_buyer":"data.available_buyer","request_id":"data.request_id","timer":"data.min_duration","bid":"data.bid"}}',

            post_condition_key: 'available_buyer',
            post_condition_operator: 'is_equal',
            post_condition_value: 'true',

            post_url: 'https://api.servicedirect.com/partners/request/<podd_start>request_id<podd_end>/accept',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json"}',
            post_data: '{"sd_api_key":"TEMPLATE_SD_API_KEY"}',
            post_output_map: '{"PostOutputMap":{"number":"data.phone_number"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Service Direct API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Service Direct request returns a valid transfer number, Retreaver will open the Service Direct integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Service Direct integrated buyer.\n\n2) Update the 'Ping Data' TEMPLATE_SERVICE_CATEGORY & TEMPLATE_SD_API_KEY fields and the 'Post Data' TEMPLATE_SD_API_KEY field to match with the instructions provided by Service Direct.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "service_category",
                property_name: "Service Direct Service Category",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_SERVICE_CATEGORY"
            },
            {
                property_id: "sd_api_key",
                property_name: "Service Direct SD API Key",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_SD_API_KEY"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    accidentdotcom_availability: {
        fields: {
            output_tag_prefix: 'accident_dot_com_preping_12345',

            ping_url: 'https://api.accident.com/api/lead-ping',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","api-key":"TEMPLATE_API_KEY","api-secret":"TEMPLATE_API_SECRET"}',
            ping_data: '{"lead_email": "[email]", "lead_phone": "+1[nanp_caller_number]"}',
            ping_output_map: '{"PingOutputMap":{"duplicate":"response.duplicate"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a boolean tag type, enter the following: \n'OUTPUT_TAG_PREFIX_duplicate' as the key, \n'equals' as the operator, \n'false' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Accident.com Availability API to request a boolean 'duplicate' response value representing if the lead is unique. If the 'duplicate' response equals 'false', Retreaver will open the Enhance integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Accident.com integrated buyer.\n\n2) Update the 'Ping Headers' field to match with the instructions provided by Accident.com.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_key",
                property_name: "Accident.com API Key",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            },
            {
                property_id: "api_secret",
                property_name: "Accident.com API Secret",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_API_SECRET"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_duplicate",
                "operator": "==",
                "value": "false"
            },
        ]
    },
    leadportal_ping_post: {
        fields: {
            output_tag_prefix: 'leadportal_12345',

            ping_url: 'https://TEMPLATE_URL.leadportal.com/new_api/api.php?Mode=ping&Format=JSON&Key=TEMPLATE_KEY&API_Action=TEMPLATE_ACTION&TYPE=TEMPLATE_TYPE&SRC=TEMPLATE_SOURCE&Terminating_Phone=TEMPLATE_TERMINATING_PHONE&Return_Best_Price=1',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"bid":"response.price","timer":"response.min_duration","lead_id":"response.lead_id"}}',

            post_condition_key: 'bid',
            post_condition_operator: 'is_greater_than',
            post_condition_value: '0',

            post_url: 'https://TEMPLATE_URL.leadportal.com/new_api/api.php?Mode=post&Format=JSON&Key=TEMPLATE_KEY&API_Action=TEMPLATE_ACTION&TYPE=TEMPLATE_TYPE&SRC=TEMPLATE_SOURCE&Terminating_Phone=TEMPLATE_TERMINATING_PHONE&Lead_ID=<podd_start>lead_id<podd_end>&Return_Best_Price=1&Origin_Phone_Country_Code=1&Origin_Phone=[nanp_caller_number]',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            post_data: '',
            post_output_map: '{"PostOutputMap":{"post_status":"response.status"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and ensure the 'Number' matches the terminating phone value: 'TEMPLATE_TERMINATING_PHONE'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Tag your buyer with 'OUTPUT_TAG_PREFIX_bid' 'is_greater_than' '0' to ensure the buyer is only routed when a bid is returned.\n\n7) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the LeadPortal API to request for a potential conversion bid and conversion timer. If the LeadPortal request returns a valid bid, Retreaver will open the LeadPortal integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the LeadPortal integrated buyer.\n\n2) Update the 'Ping URL' and 'Post URL' including: TEMPLATE_URL, TEMPLATE_KEY, TEMPLATE_ACTION, TEMPLATE_TYPE, TEMPLATE_SOURCE & TEMPLATE_TERMINATING_PHONE fields with the values provided by LeadPortal.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "leadportal_url",
                property_name: "LeadPortal URL",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "https://TEMPLATE_URL.leadportal.com/new_api/api.php"
            },
            {
                property_id: "api_key",
                property_name: "LeadPortal Key",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_KEY"
            },
            {
                property_id: "api_action",
                property_name: "LeadPortal API Action",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_ACTION"
            },
            {
                property_id: "type",
                property_name: "LeadPortal Type",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_TYPE"
            },
            {
                property_id: "source",
                property_name: "LeadPortal Source",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_SOURCE"
            },
            {
                property_id: "terminating_phone",
                property_name: "LeadPortal Terminating Phone",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_TERMINATING_PHONE"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    ringpartner_search_callback_ping_post: {
        fields: {
            output_tag_prefix: 'ringpartner_12345',

            ping_url: 'https://api.rtcb.io/listings/search/?key=TEMPLATE_API_KEY&keyword=TEMPLATE_KEYWORD&zip=[caller_zip]',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"bid":"0.payout","timer":"0.conversionDuration","request_id":"0.requestId"}}',

            post_condition_key: 'bid',
            post_condition_operator: 'is_greater_than',
            post_condition_value: '0',

            post_url: 'https://api.rtcb.io/listings/callback/?key=TEMPLATE_API_KEY&request_id=<podd_start>request_id<podd_end>',
            post_method: 'GET',
            post_headers: '',
            post_data: '',
            post_output_map: '{"PostOutputMap":{"number":"number"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the RingPartner API to request for a potential transfer number, conversion bid and conversion timer. If the RingPartner request returns a valid transfer number, Retreaver will open the RingPartner integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the RingPartner integrated buyer.\n\n2) Update the 'Ping URL' and 'Post URL' including: TEMPLATE_API_KEY, TEMPLATE_KEYWORD fields with the values provided by RingPartner.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_key",
                property_name: "RingPartner Key",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            },
            {
                property_id: "keyword",
                property_name: "RingPartner Keyword",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_KEYWORD"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    jangl_single_bid: {
        fields: {
            output_tag_prefix: 'jangl_12345',

            ping_url: 'https://calls-api.jangl.com/v1/single_bid',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","Authorization":"Token TEMPLATE_AUTHORIZATION_TOKEN"}',
            ping_data: '{"caller_phone":"[nanp_caller_number]","filters":{"currently_insured":"TEMPLATE_CURRENTLY_INSURED_VALUE"},"contact":{"zip_code":"[caller_zip]"}}',
            ping_output_map: '{"PingOutputMap":{"number":"phone_number","bid":"payout","timer":"purchase_duration"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Jangl Single Bid API to request for a potential conversion bid. If the Jangl Single Bid request returns a valid conversion bid, Retreaver will open the Jangl integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Jangl integrated buyer.\n\n2) Update the 'Ping Header's 'TEMPLATE_AUTHORIZATION_TOKEN' with the value provided by Jangl.\n\n3) Update the 'Ping Data' 'TEMPLATE_CURRENTLY_INSURED_VALUE' field by hardcoding it as 'true' 'false' or place a Retreaver [replacement_token] in its place.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "currently_insured_value",
                property_name: "Jangl Currently Insured Value",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_CURRENTLY_INSURED_VALUE"
            },
            {
                property_id: "authorization_token",
                property_name: "Jangl Authorization Token",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_AUTHORIZATION_TOKEN"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    dialpad_agent_availability: {
        fields: {
            output_tag_prefix: 'dialpad_12345',

            ping_url: 'https://dialpad.com/api/v2/callcenters/TEMPLATE_URL_CODE/status?apikey=TEMPLATE_API_KEY',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"capacity":"capacity","status":"availability.status"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_capacity' as the key, \n'greater than' as the operator, \n'0' as the value.\n\n4) Using a text tag type, enter the following: \n'OUTPUT_TAG_PREFIX_status' as the key, \n'equal' as the operator, \n'open' as the value.\n\n5) Press 'add' on the tag wizard.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the DialPad Agent Availability API to request a numeric 'capacity' response value representing the number of agents available to take a call. If the 'capacity' response value is above 0, Retreaver will open the DialPad integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the DialPad integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by DialPad.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "dialpad_url",
                property_name: "DialPad API Url",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://dialpad.com/api/v2/callcenters/TEMPLATE_URL_CODE/status?apikey=TEMPLATE_API_KEY"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_capacity",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    enrollhere_agent_availability_by_export: {
        fields: {
            output_tag_prefix: 'enrollhere_12345',

            ping_url: 'https://importer.enrollhere.com/export/data?channelId=TEMPLATE_CHANNEL_ID&userId=TEMPLATE_USER_ID&accessKey=TEMPLATE_ACCESS_KEY&filter_state=[caller_state]',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"count":"data.count","available":"available"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_count' as the key, \n'greater than' as the operator, \n'0' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the EnrollHere Agent Availability API to request a numeric 'count' response value representing the number of agents available to take a call. If the 'count' response value is above 0, Retreaver will open the EnrollHere integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the EnrollHere integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by EnrollHere including the TEMPLATE_CHANNEL_ID,TEMPLATE_USER_ID & TEMPLATE_ACCESS_KEY values.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "channel_id",
                property_name: "EnrollHere Channel Id",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_CHANNEL_ID"
            },
            {
                property_id: "user_id",
                property_name: "EnrollHere User Id",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_USER_ID"
            },
            {
                property_id: "access_key",
                property_name: "EnrollHere Access Key",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_ACCESS_KEY"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_count",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    enrollhere_agent_availability: {
        fields: {
            output_tag_prefix: 'enrollhere_12345',

            ping_url: 'https://api.enrollhere.com/dialer/availability/byQueue/TEMPLATE_QUEUEID?phone=[nanp_caller_number]',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"count":"count","available":"available"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_count' as the key, \n'greater than' as the operator, \n'0' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the EnrollHere Agent Availability API to request a numeric 'count' response value representing the number of agents available to take a call. If the 'count' response value is above 0, Retreaver will open the EnrollHere integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the EnrollHere integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by EnrollHere including the TEMPLATE_QUEUEID value.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "queue_id",
                property_name: "EnrollHere Queue Id",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_QUEUEID"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_count",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    preping_agent_availability: {
        fields: {
            output_tag_prefix: 'preping_12345',

            ping_url: 'http://pre-ping.com/ls/mca/agentAvail.php?campaignID=TEMPLATE_CAMPAIGN_ID&state=[caller_state]',
            ping_method: 'POST',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"status":"status","message":"message"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a text tag type, enter the following: \n'OUTPUT_TAG_PREFIX_message' as the key, \n'equals' as the operator, \n'Agent Available' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Pre-Ping Agent Availability API to request a text 'message' response value representing if agents are available to take a call. If the 'message' response value is 'Agent Available', Retreaver will open the Pre-Ping integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Pre-Ping integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Pre-Ping including the TEMPLATE_CAMPAIGN_ID value.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "campaign_id",
                property_name: "Pre-Ping Campaign Id",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_ID"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_message",
                "operator": "==",
                "value": "Agent Available"
            },
        ]
    },
    dnc_scrub: {
        fields: {
            output_tag_prefix: 'dncscrub',

            ping_url: 'https://www.dncscrub.com/app/main/rpc/scrub?phoneList=[nanp_caller_number]&version=5&output=json',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded","loginId":"TEMPLATE_LOGIN_ID"}',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"result_code":"0.ResultCode"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a text tag type, enter the following: \n'OUTPUT_TAG_PREFIX_result_code' as the key, \n'matches' as the operator, \n'|C|E|Y|X|O|R|' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the DNC Scrub API to return a text 'result_code' response value representing if this lead is on a DNC (Do Not Call) list. If the 'result_code' response value is equal to any of the following: 'C,E,Y,X,O,R' - Retreaver will open the DNC Scrub integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Ping Headers' field to include your DNC Scrub 'LoginId' by replacing the 'TEMPLATE_LOGIN_ID' value.\n\n2) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "login_id",
                property_name: "DNC Login ID",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_LOGIN_ID"
            }
        ]
    },
    yield_pro_datapost: {
        fields: {
            output_tag_prefix: 'yield_pro_12345',

            ping_url: 'https://yieldpro.io/api/v1/leads/bot',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","Authorization":"Bearer%20TEMPLATE_BEARER_TOKEN"}',
            ping_data: '{"firstName":"[first_name]","lastName":"[last_name]","phone":"[nanp_caller_number]","universal_leadid":"[jornaya_lead_id]","xxTrustedFormToken":"[trusteform_cert_url]","zip_code":"[caller_zip]","state":"[caller_state]","age":"[age]","pub_ID":"TEMPLATE_PUB_ID"}',
            ping_output_map: '{"PingOutputMap":{}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '4'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Selected: When a buyer is selected'.\n\n2) Use the tag wizard to apply a buyer ID tag on the webhook 'matches' field, this ensures that this webhook only triggers when a specific buyer is selected."
        },
        template_summary: {
            template_summary_text: "This webhook will post any listed and available caller data fields over to Yield Pro's database if the caller is routed to a specified buyer."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Yield Pro integrated buyer.\n\n2) Update the 'Ping Header' authorization token.\n\n3) Update the 'Ping Data' using the instructions provided by Yield Pro, be sure to also replace the TEMPLATE_PUB_ID value with the value provided by Yield Pro.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "bearer_token",
                property_name: "Yield Pro Bearer Token",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_BEARER_TOKEN"
            },
            {
                property_id: "pub_id",
                property_name: "Yield Pro Pub ID",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_PUB_ID"
            }
        ]
    },
    onyx_ping: {
        fields: {
            output_tag_prefix: 'onyx_12345',

            ping_url: 'https://communication.onyxplatform.com/api/v1/external/organizations/XXXX/campaigns/XX/sources/XXX/utilization',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","Authorization":"TEMPLATE_AUTHORIZATION_TOKEN"}',
            ping_data: '{"lead_phone_number":"[nanp_caller_number]","state":"[caller_state]","zip_code":"[caller_zip]"}',
            ping_output_map: '{"PingOutputMap":{"number":"phone_number","timer":"duration","bid":"bid"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Onyx API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Onyx request returns a valid transfer number, Retreaver will open the Onyx integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Onyx integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Onyx.\n\n3) Update the ping headers to include the authorization token provided by Onyx.\n\n4) Optionally, update the 'Ping Data' field if you would like to submit additional caller data along with the request.\n\n5) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "onyx_url",
                property_name: "Onyx Url",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://communication.onyxplatform.com/api/v1/external/organizations/XXXX/campaigns/XX/sources/XXX/utilization"
            },
            {
                property_id: "auth_token",
                property_name: "Onyx Auth Token",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_AUTHORIZATION_TOKEN"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    ratequote_ping_post: {
        fields: {
            output_tag_prefix: 'ratequote_12345',

            ping_url: 'https://call-optimizer.ratequote.com/pings',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","x-api-key":"TEMPLATE_X_API_KEY"}',
            ping_data: '{"consumerANI":"[nanp_caller_number]","product":"TEMPLATE_PRODUCT","sourceCampaignId":"TEMPLATE_CAMPAIGN_SOURCE_ID","sourceId":"TEMPLATE_SOURCE_ID","state":"[caller_state]","zip":"[caller_zip]"}',
            ping_output_map: '{"PingOutputMap":{"id":"id","bid":"bid","timer":"payoutDuration","number":"destinationNumber"}}',

            post_condition_key: 'bid',
            post_condition_operator: 'is_greater_than',
            post_condition_value: '0',

            post_url: 'https://call-optimizer.ratequote.com/contacts',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json","x-api-key":"TEMPLATE_X_API_KEY"}',
            post_data: '{"pingId":"<podd_start>id<podd_end>","consumerANI":"[nanp_caller_number]","product":"TEMPLATE_PRODUCT","sourceCampaignId":"TEMPLATE_CAMPAIGN_SOURCE_ID","sourceId":"TEMPLATE_SOURCE_ID","state":"[caller_state]","zip":"[caller_zip]"}',
            post_output_map: '{"PostOutputMap":{"post_id":"id","post_pingId":"pingId"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the RateQuote API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the RateQuote request returns a valid transfer number, Retreaver will open the RateQuote integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the RateQuote integrated buyer.\n\n2) Update the 'Ping & Post Headers' field to include the 'x-api-key' value provided by RateQuote.\n\n3) Update the 'Ping & Post Data' fields to include the 'product','campaign source id', and the 'source id' values provided by RateQuote.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "ratequote_x_api_key",
                property_name: "RateQuote x-api-key",
                fields_to_replace: [
                    "ping_headers",
                    "post_headers"
                ],
                replacement_token: "TEMPLATE_X_API_KEY"
            },
            {
                property_id: "ratequote_product",
                property_name: "RateQuote Product",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_PRODUCT"
            },
            {
                property_id: "ratequote_campaign_source_id",
                property_name: "RateQuote Campaign Source ID",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_SOURCE_ID"
            },
            {
                property_id: "ratequote_source_id",
                property_name: "RateQuote Source ID",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_SOURCE_ID"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    insurance_io_ping: {
        fields: {
            output_tag_prefix: 'insurance_io_12345',

            ping_url: 'https://api.insurance.io/api/v1/calls/ping',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","Authorization":"Bearer%20TEMPLATE_AUTHORIZATION_TOKEN"}',
            ping_data: '{"lead":{"lead_type_id":6,"traffic_tier":"google","contact":{"state":"[caller_state]","zip":"[caller_zip]","primary_phone":"[nanp_caller_number]"},"inbound":true}}',
            ping_output_map: '{"PingOutputMap":{"number":"buyers[0].transfer_number","timer":"buyers[0].billable_duration","bid":"buyers[0].bid","buyer_name":"buyers[0].buyer"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Insurance.io API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Insurance.io request returns a valid transfer number, Retreaver will open the Insurance.io integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Insurance.io integrated buyer.\n\n2) Update the ping headers to include the authorization token provided by Insurance.io.\n\n3) Optionally, update the 'Ping Data' field if you would like to submit additional caller data along with the request.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "auth_token",
                property_name: "Insurance.io Auth Token",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_AUTHORIZATION_TOKEN"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    nolo_ping: {
        fields: {
            output_tag_prefix: 'nolo_12345',

            ping_url: 'https://affiliates.nolo.com/api/v1/lead/api-ping/',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"security_token":"TEMPLATE_SECURITY_TOKEN","affiliate_token":"TEMPLATE_AFFILIATE_TOKEN","lead_identifier":"99","zip_code":"[caller_zip]","email":"","phone":"[nanp_caller_number]","practice_area_id":"TEMPLATE_PRACTICE_AREA_ID"}',
            ping_output_map: '{"PingOutputMap":{"bid":"price","status":"status"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n3) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n4) Under Tag List, tag the buyer with 'OUTPUT_TAG_PREFIX_status' == 'OK'. \n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Nolo API to request for a potential conversion bid. If the Nolo request returns a valid bid and a status of 'OK', Retreaver will open the Nolo integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Nolo integrated buyer.\n\n2) Update the ping data to include the security, affiliate and practice area tokens provided by Nolo.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "security_token",
                property_name: "Nolo Security Token",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_SECURITY_TOKEN"
            },
            {
                property_id: "affiliate_token",
                property_name: "Nolo Affiliate Token",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_AFFILIATE_TOKEN"
            },
            {
                property_id: "practice_area",
                property_name: "Nolo Practice Area Id",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_PRACTICE_AREA_ID"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            },
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_status",
                "operator": "==",
                "value": "OK"
            },
        ]
    },
    inbounds_ping: {
        fields: {
            output_tag_prefix: 'inbounds_12345',

            ping_url: 'https://code.inbounds.com/ping/calls-inbounds/TEMPLATE?supplier=TEMPLATE&phone=[nanp_caller_number]&zip_code=[caller_zip]',
            ping_method: 'POST',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"bid":"bid","timer":"call_min_duration"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n3) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n4) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Inbounds.com API to request for a potential conversion bid. If the Inbounds.com request returns a valid bid, Retreaver will open the Inbounds.com integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Inbounds.com integrated buyer.\n\n2) Update the ping URL to match the requirements provided by Inbounds.com.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "inbounds_url",
                property_name: "Inbounds Url",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://code.inbounds.com/ping/calls-inbounds/TEMPLATE?supplier=TEMPLATE&phone=[nanp_caller_number]&zip_code=[caller_zip]"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    salesradix_availability: {
        fields: {
            output_tag_prefix: 'salesradix_12345',

            ping_url: 'https://api.salesradix.com/agentavailability/?SubSourceID=TEMPLATE_SUBSOURCE_ID&PhoneNumber=[nanp_caller_number]&State=[caller_state]&PingID=[call_uuid]&vertical=TEMPLATE_VERTICAL&ResponseType=json',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"result":"result"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a text tag type, enter the following: \n'OUTPUT_TAG_PREFIX_result' as the key, \n'equals' as the operator, \n'Available' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the SalesRadix Agent Availability API to request a text 'result' response value representing the availability of agents ready to take a call. If the 'result' response value is 'Available', Retreaver will open the SalesRadix integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the SalesRadix integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by SalesRadix.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "subsource_id",
                property_name: "SalesRadix Subsource ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_SUBSOURCE_ID"
            },
            {
                property_id: "vertical",
                property_name: "SalesRadix Vertical",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_VERTICAL"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_result",
                "operator": "==",
                "value": "Available"
            }
        ]
    },
    callgrid_ping: {
        fields: {
            output_tag_prefix: 'callgrid_12345',

            ping_url: 'https://bid.callgrid.com/api/ping/TEMPLATE_URL_ID?CallerId=[caller_number]',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"available":"available","number":"PhoneNumber","code":"code"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Tag the buyer with OUTPUT_TAG_PREFIX_available = \"true\".\n\n4) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Call Grid API to request for a potential dynamic transfer number and an availability status. If the Call Grid request returns a valid transfer number and an available status of true, Retreaver will open the Call Grid integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Call Grid integrated buyer.\n\n2) Update the ping url to include the url ID provided by Call Grid.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "url_id",
                property_name: "Call Grid URL ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_URL_ID"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_available",
                "operator": "==",
                "value": "true"
            }
        ]
    },
    callgrid_bid: {
        fields: {
            output_tag_prefix: 'callgrid_12345',

            ping_url: 'https://bid.callgrid.com/api/bid/TEMPLATE_URL_ID?CallerId=[caller_number]',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"bid":"dynamicBid","timer":"dynamicDuration","number":"dynamicPhoneNumber","dynamic_sip":"dynamicSipAddress","code":"code"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Call Grid API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Call Grid request returns a valid transfer number, Retreaver will open the Call Grid integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Call Grid integrated buyer.\n\n2) Update the ping url to include the url ID provided by Call Grid.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "url_id",
                property_name: "Call Grid URL ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_URL_ID"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            },
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_code",
                "operator": "==",
                "value": "1000"
            }
        ]
    },
    intelelead_ping_post: {
        fields: {
            output_tag_prefix: 'intelelead_12345',

            ping_url: 'https://www.intelelead.com/offer',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","api-key":"TEMPLATE_API_KEY","dp-key":"TEMPLATE_DP_KEY","vendor":"TEMPLATE_VENDOR"}',
            ping_data: '{"demographics":{"last_name":null,"first_name":null,"address":{"zipcode":"[caller_zip]","address1":"Unavailable","state":"[caller_state]","address2":null,"city":"[caller_city]"},"ani":"[nanp_caller_number]","send_to":"TEMPLATE_SEND_TO","additional_data":{"trusted_form_url":null,"offer_type":"exclusive","age":null,"lead_type":"Call","campaign":"WT"}}}',
            ping_output_map: '{"PingOutputMap":{"result":"result","bid":"price","offer_id":"offer_id"}}',

            post_condition_key: 'offer_id',
            post_condition_operator: 'exists',
            post_condition_value: 'true',

            post_url: 'https://www.intelelead.com/lead',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json","api-key":"TEMPLATE_API_KEY","dp-key":"TEMPLATE_DP_KEY","vendor":"TEMPLATE_VENDOR"}',
            post_data: '{"offer_id":"<podd_start>offer_id<podd_end>","demographics":{"last_name":null,"first_name":null,"address":{"zipcode":"[caller_zip]","address1":"Unavailable","state":"[caller_state]","address2":null,"city":"[caller_city]"},"ani":"[nanp_caller_number]","send_to":"TEMPLATE_SEND_TO","additional_data":{"trusted_form_url":null,"offer_type":"exclusive","age":null,"lead_type":"Call","campaign":"WT"}}}',
            post_output_map: '{"PostOutputMap":{"message":"message"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n3) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n4) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Intelelead API to request for a potential conversion bid. If the Intelelead request returns a valid bid, Retreaver will open the Intelelead integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Intelelead integrated buyer.\n\n2) Update the 'Ping & Post Headers' field to include the 'api key', 'dp key' and 'vendor' values provided by Intelelead.\n\n3) Update the 'Ping & Post Data' fields to include the 'send to' value provided by Intelelead.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_key",
                property_name: "Intelelead API Key",
                fields_to_replace: [
                    "ping_headers",
                    "post_headers"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            },
            {
                property_id: "dp_key",
                property_name: "Intelelead DP Key",
                fields_to_replace: [
                    "ping_headers",
                    "post_headers"
                ],
                replacement_token: "TEMPLATE_DP_KEY"
            },
            {
                property_id: "vendor",
                property_name: "Intelelead Vendor",
                fields_to_replace: [
                    "ping_headers",
                    "post_headers"
                ],
                replacement_token: "TEMPLATE_VENDOR"
            },

            {
                property_id: "send_to",
                property_name: "Intelelead Send To",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_SEND_TO"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    wiserleads_ping_post: {
        fields: {
            output_tag_prefix: 'wiserleads_12345',

            ping_url: 'https://api.wiserleads.com/services/calls/ping',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"campaign":"TEMPLATE_CAMPAIGN","campaign_token":"TEMPLATE_CAMPAIGN_TOKEN","zipcode":"[caller_zip]","keyword":"TEMPLATE_KEYWORD","source":"[publisher_id]"}',
            ping_output_map: '{"PingOutputMap":{"success":"success","call_token":"call_token","bid":"payout","timer":"duration"}}',

            post_condition_key: 'call_token',
            post_condition_operator: 'exists',
            post_condition_value: 'true',

            post_url: 'https://api.wiserleads.com/services/calls/post',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json"}',
            post_data: '{"campaign":"TEMPLATE_CAMPAIGN","campaign_token":"TEMPLATE_CAMPAIGN_TOKEN","call_token":"<podd_start>call_token<podd_end>","caller_id":"+1[nanp_caller_number]"}',
            post_output_map: '{"PostOutputMap":{"post_success":"success","number":"number","post_call_token":"call_token"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the WiserLeads API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the WiserLeads request returns a valid transfer number, Retreaver will open the WiserLeads integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the WiserLeads integrated buyer.\n\n2) Update the 'Ping & Post Data' fields to include the 'campaign','campaign token', and the 'keyword' values provided by WiserLeads.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "campaign",
                property_name: "WiserLeads Campaign",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN"
            },
            {
                property_id: "campaign_token",
                property_name: "WiserLeads Campaign Token",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_TOKEN"
            },
            {
                property_id: "keyword",
                property_name: "WiserLeads Keyword",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_KEYWORD"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    inquirly_ping_post: {
        fields: {
            output_tag_prefix: 'inquirly_12345',

            ping_url: 'https://app.inquirly.com/new_api/api.php?Mode=ping&Format=JSON&API_Action=iprSubmitLead&Terminating_Phone_Country_Code=1&Return_Best_Price=1&action=detail&func=pingPostLead&TYPE=9&Key=TEMPLATE_KEY&SRC=TEMPLATE_SOURCE&Terminating_Phone=TEMPLATE_TERMINATING_PHONE&ZIP=[caller_zip]&Task=TEMPLATE_TASK',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"status":"response.status","lead_id":"response.lead_id","bid":"response.price"}}',

            post_condition_key: 'status',
            post_condition_operator: 'is_equal',
            post_condition_value: 'Matched',

            post_url: 'https://app.inquirly.com/new_api/api.php?Mode=post&Format=JSON&API_Action=iprSubmitLead&Terminating_Phone_Country_Code=1&Return_Best_Price=1&action=detail&func=pingPostLead&TYPE=9&Key=TEMPLATE_KEY&SRC=TEMPLATE_SOURCE&Terminating_Phone=TEMPLATE_TERMINATING_PHONE&ZIP=[caller_zip]&Origin_Phone_Country_Code=1&App_ID=888&Task=TEMPLATE_TASK&Origin_Phone=[nanp_caller_number]&Lead_ID=<podd_start>lead_id<podd_end>&Origin_Phone_Area_Code=[nanp_caller_number_area_code]&Origin_Phone_Prefix=[nanp_caller_number_prefix]&Origin_Phone_Suffix=[nanp_caller_number_suffix]&Start_Date_Time=[current_time_year_et]-[current_time_month_et]-[current_time_day_et] [current_time_hour_et]:[current_time_minute_et]:[current_time_second_et]',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            post_data: '',
            post_output_map: '{"PostOutputMap":{"post_status":"response.status"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n3) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n4) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Inquirly API to request for a potential conversion bid. If the Inquirly request returns a valid bid, Retreaver will open the Inquirly integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Inquirly integrated buyer.\n\n2) Update the 'Ping & Post URL' fields to include the 'key','source', 'terminating phone' and the 'task' values provided by Inquirly.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "key",
                property_name: "Inquirly Key",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_KEY"
            },
            {
                property_id: "source",
                property_name: "Inquirly Source",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_SOURCE"
            },
            {
                property_id: "terminating_phone",
                property_name: "Inquirly Terminating Phone",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_TERMINATING_PHONE"
            },
            {
                property_id: "task",
                property_name: "Inquirly Task",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_TASK"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            },
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_post_status",
                "operator": "==",
                "value": "Success"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    media_alpha_ping: {
        fields: {
            output_tag_prefix: 'media_alpha_12345',

            ping_url: 'https://insurance.mediaalpha.com/call-transfers.json',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"api_token":"TEMPLATE_API_TOKEN","call_type":"Inbound","data":{"phone":"[nanp_caller_number]","zip":"[caller_zip]"},"ip":"","local_hour":12,"max":3,"placement_id":"TEMPLATE_PLACEMENT_ID","sub_1":"","transfer_type":"cold","ua":"","url":"","version":17}',
            ping_output_map: '{"PingOutputMap":{"bid":"call_transfers%5B0%5D.bid","timer":"call_transfers%5B0%5D.qualification_duration","number":"call_transfers%5B0%5D.phone_num","error":"error"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Media Alpha API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Media Alpha request returns a valid transfer number, Retreaver will open the Media Alpha integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Media Alpha integrated buyer.\n\n2) Update the 'TEMPLATE_API_TOKEN' and then update the 'TEMPLATE_PLACEMENT_ID' values in the 'Ping Data' field with the values provided by Media Alpha.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_token",
                property_name: "Media Alpha API Token",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_API_TOKEN"
            },
            {
                property_id: "placement_id",
                property_name: "Media Alpha Placement ID",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_PLACEMENT_ID"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    arroyo_media_ping: {
        fields: {
            output_tag_prefix: 'arroyo_media_12345',

            ping_url: 'https://api.arroyomedia.com/pingpost/v1?caller=[nanp_caller_number]&zip=[caller_zip]&campaign_token=TEMPLATE_CAMPAIGN_TOKEN',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"bid":"carrier%5B0%5D.payout","timer":"carrier[0].duration","number":"carrier[0].phone","ping_id":"carrier[0].ping_id"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Arroyo Media API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Arroyo Media request returns a valid transfer number, Retreaver will open the Arroyo Media integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Arroyo Media integrated buyer.\n\n2) Update the 'TEMPLATE_CAMPAIGN_TOKEN' value in the 'Ping Url' field with the value provided by Arroyo Media.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "campaign_token",
                property_name: "Arroyo Media Campaign Token",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_TOKEN"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    axquotes_ping: {
        fields: {
            output_tag_prefix: 'axquotes_12345',

            ping_url: 'https://policy.axquotes.com/api/integration/pingex',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","Authorization":"Bearer%20TEMPLATE_BEARER_TOKEN"}',
            ping_data: '{"customer":{"phone_number":"[nanp_caller_number]","zip":"[caller_zip]"},"campaign":"TEMPLATE_CAMPAIGN_DID","groupId":"TEMPLATE_GROUP_ID","geo":"[caller_state]"}',
            ping_output_map: '{"PingOutputMap":{"accepted":"accepted","number":"phoneNumber","bid":"bid"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the AxQuotes API to request for a potential conversion bid and dynamic transfer number. If the AxQuotes request returns a valid transfer number, Retreaver will open the AxQuotes integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the AxQuotes integrated buyer.\n\n2) Update the 'TEMPLATE_BEARER_TOKEN' value in the 'Ping Headers' field, and the 'TEMPLATE_CAMPAIGN_DID' & 'TEMPLATE_GROUP_ID' fields in the 'Ping Data' fields with the value provided by AxQuotes.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "bearer_token",
                property_name: "AxQuotes Bearer Token",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_BEARER_TOKEN"
            },
            {
                property_id: "campaign_did",
                property_name: "AxQuotes Campaign DID",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_DID"
            },
            {
                property_id: "group_id",
                property_name: "AxQuotes Group ID",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_GROUP_ID"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    click_thesis_ping: {
        fields: {
            output_tag_prefix: 'click_thesis_12345',

            ping_url: 'https://www.clickthesis.com/api/Call/Ping',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","x-api-key":"TEMPLATE_X_API_KEY"}',
            ping_data: '{"sub_id":"[call_uuid]","unique_id":"[call_uuid]","test_lead":"false","phone":"[nanp_caller_number]","zip_code":"[caller_zip]","project_type":"TEMPLATE_PROJECT_TYPE"}',
            ping_output_map: '{"PingOutputMap":{"bid":"bidPrice","timer":"callDuration","number":"transferNumber"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Click Thesis API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Click Thesis request returns a valid transfer number, Retreaver will open the Click Thesis integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Click Thesis integrated buyer.\n\n2) Update the 'TEMPLATE_X_API_KEY' value in the 'Ping Headers' field, and the 'TEMPLATE_PROJECT_TYPE' value in the 'Ping Data' field with the values provided by Click Thesis.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_key",
                property_name: "Click Thesis X-Api-Key",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_X_API_KEY"
            },
            {
                property_id: "project_type",
                property_name: "Click Thesis Project Type",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_PROJECT_TYPE"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    callsync_ping_post: {
        fields: {
            output_tag_prefix: 'call_sync_12345',

            ping_url: 'https://dash.callsync.io/api/calls/ping',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"zipcode":"[caller_zip]","state":"[caller_state]","callerId":"[caller_number]","calledNumber":"TEMPLATE_PHONE_VALUE","vendor_call_id":"[call_uuid]","publisher_uuid":"TEMPLATE_PUBLISHER_UUID"}',
            ping_output_map: '{"PingOutputMap":{"agents":"agents","bid":"bid_amount"}}',

            post_condition_key: 'bid',
            post_condition_operator: 'is_greater_than',
            post_condition_value: '0',

            post_url: 'https://dash.callsync.io/api/calls/post',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json"}',
            post_data: '{"zipcode":"[caller_zip]","state":"[caller_state]","callerId":"[caller_number]","calledNumber":"TEMPLATE_PHONE_VALUE","vendor_call_id":"[call_uuid]","publisher_uuid":"TEMPLATE_PUBLISHER_UUID","api_key":"TEMPLATE_API_KEY","return_transfer_number":"true"}',
            post_output_map: '{"PostOutputMap":{"post_agents":"agents","number":"transfer_number"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Call Sync API to request for a potential conversion bid and dynamic transfer number. If the Call Sync request returns a valid transfer number, Retreaver will open the Call Sync integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Call Sync integrated buyer.\n\n2) Update the 'Ping & Post Data' fields to include the 'TEMPLATE_PHONE_VALUE', 'TEMPLATE_PUBLISHER_UUID' & 'TEMPLATE_API_KEY' values provided by Call Sync.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "call_sync_phone_value",
                property_name: "Call Sync Phone Value",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_PHONE_VALUE"
            },
            {
                property_id: "call_sync_publisher_uuid",
                property_name: "Call Sync Publisher UUID",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_PUBLISHER_UUID"
            },
            {
                property_id: "call_sync_product",
                property_name: "Call Sync Product",
                fields_to_replace: [
                    "post_data"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    intelhouse_ping_post: {
        fields: {
            output_tag_prefix: 'intelhouse_12345',

            ping_url: 'https://api.call.intelhouse.net/v1/rtb/ping',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"publisher_id":"TEMPLATE_PUBLISHER_ID","campaign_id":"TEMPLATE_CAMPAIGN_ID","caller_number":"[nanp_caller_number]","caller_zip":"[caller_zip]"}',
            ping_output_map: '{"PingOutputMap":{"bid":"payout","timer":"duration","token":"token"}}',

            post_condition_key: 'bid',
            post_condition_operator: 'is_greater_than',
            post_condition_value: '0',

            post_url: 'https://api.call.intelhouse.net/v1/rtb/post',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json"}',
            post_data: '{"publisher_id":"TEMPLATE_PUBLISHER_ID","campaign_id":"TEMPLATE_CAMPAIGN_ID","token":"<podd_start>token<podd_end>"}',
            post_output_map: '{"PostOutputMap":{"number":"number"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the IntelHouse API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the IntelHouse request returns a valid transfer number, Retreaver will open the IntelHouse integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the IntelHouse integrated buyer.\n\n2) Update the 'Ping & Post Data' fields to include the 'TEMPLATE_PUBLISHER_ID' & 'TEMPLATE_CAMPAIGN_ID' values provided by IntelHouse.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "intelhouse_publisher_id",
                property_name: "IntelHouse Publisher ID",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_PUBLISHER_ID"
            },
            {
                property_id: "intelhouse_campaign_id",
                property_name: "IntelHouse Campaign Id",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_ID"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    google_analytics_data_post: {
        fields: {
            output_tag_prefix: 'google_analytics',

            ping_url: 'https://www.google-analytics.com/mp/collect?measurement_id=TEMPLATE_MEASUREMENT_ID&api_secret=TEMPLATE_API_SECRET&en=TEMPLATE_EVENT_NAME',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"client_id":"[cid]","events":[{"name":"call_selected","params":{"call_id":"[call_uuid]","caller_number":"[nanp_caller_number]"}}]}',
            ping_output_map: '{"PingOutputMap":{}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '4'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Selected: When a buyer is selected'."
        },
        template_summary: {
            template_summary_text: "This webhook will data-post call details over to Google Analytics, once the call is selected for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Ping Url' using the instructions provided by Google Analytics, including the 'TEMPLATE_MEASUREMENT_ID', 'TEMPLATE_API_SECRET' & 'TEMPLATE_EVENT_NAME' values.\n\n2) Update the 'Ping Data' fields to include any required values you wish to pass.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "measurement_id",
                property_name: "Google Measurement ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_MEASUREMENT_ID"
            },
            {
                property_id: "api_secret",
                property_name: "Google API Secret",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_API_SECRET"
            },
            {
                property_id: "event_name",
                property_name: "Google Event Name",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_EVENT_NAME"
            }
        ]
    },
    facebook_data_post: {
        fields: {
            output_tag_prefix: 'facebook_datapost',

            ping_url: 'https://www.facebook.com/tr?id=TEMPLATE_PIXEL_ID&ev=TEMPLATE_EVENT_VALUE&noscript=1',
            ping_method: 'POST',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '4'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Selected: When a buyer is selected'."
        },
        template_summary: {
            template_summary_text: "This webhook will data-post a 'Facebook Event Value' over to a Facebook pixel, once the call is selected for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Ping Url' using the instructions provided by Facebook, including the 'TEMPLATE_PIXEL_ID' & 'TEMPLATE_EVENT_NAME' values.\n\n2) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "pixel_id",
                property_name: "Facebook Pixel ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_PIXEL_ID"
            },
            {
                property_id: "event_value",
                property_name: "Facebook Event Value",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_EVENT_VALUE"
            }
        ]
    },
    jornaya_single_query: {
        fields: {
            output_tag_prefix: 'jornaya_single_query',

            ping_url: 'https://api.leadid.com/SingleQuery?lac=TEMPLATE_lac&lak=TEMPLATE_lak&id=[TEMPLATE_JORNAYA_ID_TAG]&lpc=&data',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"authentic":"audit.authentic"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB."
        },
        template_summary: {
            template_summary_text: "This webhook will trigger the Jornaya 'Single Query' method to validate an incoming Jornaya Id value."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Ping Url' using the instructions provided by Jornaya, including the 'TEMPLATE_lac', 'TEMPLATE_lak' & 'TEMPLATE_JORNAYA_ID_TAG' values.\n\n2) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "lac",
                property_name: "Jornaya 'lac'",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_lac"
            },
            {
                property_id: "lak",
                property_name: "Jornaya 'lak'",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_lak"
            },
            {
                property_id: "jornaya_tag",
                property_name: "Jornaya ID Tag",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_JORNAYA_ID_TAG"
            }
        ]
    },
    letsmakealead_ping_post: {
        fields: {
            output_tag_prefix: 'letsmakealead_12345',

            ping_url: 'http://call.letsmakealead.com/Ping_Partner.php?partnerid=TEMPLATE_PARTNER_ID&subid=match&key=TEMPLATE_KEY&numcategory=TEMPLATE_NUM_CATEGORY&resptype=JSON&transfer_type=1&zipcode=[caller_zip]&telephone=[nanp_caller_number]',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"bid":"price","timer":"call_duration","token":"token","result":"result"}}',

            post_condition_key: 'result',
            post_condition_operator: 'is_equal',
            post_condition_value: 'ACCEPTED',

            post_url: 'http://call.letsmakealead.com/Post_Partner.php?partnerid=TEMPLATE_PARTNER_ID&subid=match&key=TEMPLATE_KEY&numcategory=TEMPLATE_NUM_CATEGORY&resptype=JSON&transfer_type=1&zipcode=[caller_zip]&telephone=[nanp_caller_number]&token=<podd_start>token<podd_end>',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            post_data: '',
            post_output_map: '{"PostOutputMap":{"number":"PhoneNumber"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the LetsMakeALead API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the LetsMakeALead request returns a valid transfer number, Retreaver will open the LetsMakeALead integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the LetsMakeALead integrated buyer.\n\n2) Update the 'Ping & Post URL' fields to include the 'TEMPLATE_PARTNER_ID', 'TEMPLATE_KEY' & 'TEMPLATE_NUM_CATEGORY' values provided by LetsMakeALead.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "letsmakealead_partner_id",
                property_name: "LetsMakeALead Partner ID",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_PARTNER_ID"
            },
            {
                property_id: "letsmakealead_key",
                property_name: "LetsMakeALead Key",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_KEY"
            },
            {
                property_id: "letsmakealead_num_category",
                property_name: "LetsMakeALead Num Category",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_NUM_CATEGORY"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    leadrilla_ping: {
        fields: {
            output_tag_prefix: 'leadrilla_12345',

            ping_url: 'https://api.leadrilla.com/calls/ping?product_id=TEMPLATE_PRODUCT_ID&affiliate_id=TEMPLATE_AFFILIATE_ID&caller_number=[nanp_caller_number]',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"number":"call_reservation.inbound_number"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Press 'Update Call Buyer' to update your buyer and complete the integration. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Leadrilla API to request for a potential dynamic transfer number. If the Leadrilla request returns a valid transfer number, Retreaver will open the Leadrilla integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Leadrilla integrated buyer.\n\n2) Update the 'Ping URL' 'TEMPLATE_PRODUCT_ID' & 'TEMPLATE_AFFILIATE_ID' with the values provided by Leadrilla.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "product_id",
                property_name: "Leadrilla Product ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_PRODUCT_ID"
            },
            {
                property_id: "affiliate_id",
                property_name: "Leadrilla Affiliate ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_AFFILIATE_ID"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            }
        ]
    },
    leadamp_ping: {
        fields: {
            output_tag_prefix: 'leadamp_12345',

            ping_url: 'https://leadamp.clearlink.com/api/v1/calls/ping',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","Authorization":"Bearer%20TEMPLATE_BEARER_TOKEN","User-Agent":"curl/7.64.1","Accept":"application/json"}',
            ping_data: '{"campaignCode":"TEMPLATE_CAMPAIGN_CODE","affiliateLeadId":"[call_uuid]","zip":"[caller_zip]","phone":"[nanp_caller_number]","call_type":"inbound"}',
            ping_output_map: '{"PingOutputMap":{"pingId":"pingId","accepted":"accepted","bid":"price.value","timer":"payoutThreshold"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n3) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n4) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the LeadAmp API to request for a potential conversion bid & conversion timer. If the LeadAmp request returns a valid bid, Retreaver will open the LeadAmp integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the LeadAmp integrated buyer.\n\n2) Update the 'TEMPLATE_BEARER_TOKEN' value in the 'Ping Headers' field, and the 'TEMPLATE_CAMPAIGN_CODE' value in the 'Ping Data' field with the values provided by LeadAmp Clearlink.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "bearer_token",
                property_name: "LeadAmp Bearer Token",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_BEARER_TOKEN"
            },
            {
                property_id: "campaign_code",
                property_name: "LeadAmp Campaign Code",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_CODE"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    mutual_of_omaha_data_post: {
        fields: {
            output_tag_prefix: 'moh_datapost',

            ping_url: 'https://api-cat.mutualofomaha.com/dsc-lead-eapi/v1/leads',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","Authorization":"Basic%20TEMPLATE_AUTHORIZATION_TOKEN"}',
            ping_data: '{"firstName":"[first_name]","middleName":"","lastName":"[last_name]","birthDate":"[dob_year]-[dob_month_2d]-[dob_day_2d]","gender":"[gender]","homePhoneNumber":"[nanp_caller_number]","mailingAddressLine1":"[address1]","mailingAddressLine2":"","mailingCity":"[caller_city]","mailingState":"[caller_state]","mailingPostalCode":"[caller_zip]","emailAddress":"[email]","leadProviderCode":"TEMPLATE_LEAD_PROVIDER_CODE","transferTFN":"TEMPLATE_TRANSFER_TFN","transferANI":"[nanp_caller_number]"}',
            ping_output_map: '{"PingOutputMap":{}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '4'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Selected: When a buyer is selected'."
        },
        template_summary: {
            template_summary_text: "This webhook will data-post call details over to Mutual Of Omaha, once the call is selected for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Ping Header' 'TEMPLATE_AUTHORIZATION_TOKEN' using the instructions provided by Mutual Of Omaha.\n\n2) Update the 'Ping Data' fields to include any required values you wish to pass including the 'TEMPLATE_LEAD_PROVIDER_CODE' & 'TEMPLATE_TRANSFER_TFN' fields.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "authorization_token",
                property_name: "MoH Authorization Token",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_AUTHORIZATION_TOKEN"
            },
            {
                property_id: "lead_provider_code",
                property_name: "MoH Lead Provider Code",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_LEAD_PROVIDER_CODE"
            },
            {
                property_id: "transfer_tfn",
                property_name: "MoH Transfer TFN",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_TRANSFER_TFN"
            }
        ]
    },
    sabal_data_post: {
        fields: {
            output_tag_prefix: 'sabal_datapost',

            ping_url: 'https://api.sabalgrp.com/leads/',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","X-API-Key":"TEMPLATE_X_API_KEY"}',
            ping_data: '{"first_name":"[first_name]","last_name":"[last_name]","number1":"[nanp_caller_number]","state":"[caller_state]","zip":"[caller_zip]"}',
            ping_output_map: '{"PingOutputMap":{}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '4'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Selected: When a buyer is selected'."
        },
        template_summary: {
            template_summary_text: "This webhook will data-post call details over to Sabal Group, once the call is selected for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Ping Headers' using the instructions provided by Sabal Group, including the 'TEMPLATE_X_API_KEY' value.\n\n2) Update the 'Ping Data' fields to include any required values you wish to pass.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "x_api_key",
                property_name: "Sabal X API Key",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_X_API_KEY"
            }
        ]
    },
    ringy_data_post: {
        fields: {
            output_tag_prefix: 'ringy_datapost',

            ping_url: 'https://app.ringy.com/api/public/leads/new-lead',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"sid":"TEMPLATE_SID","authToken":"TEMPLATE_AUTHTOKEN","phone_number":"[nanp_caller_number]","first_name":"[first_name]","last_name":"[last_name]","age":"[age]","city":"[caller_city]","phone_number":"[nanp_caller_number]","state":"[caller_state]","email":"[email]","address1":"[address1]"}',
            ping_output_map: '{"PingOutputMap":{"vendorResponseId":"vendorResponseId"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '4'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Selected: When a buyer is selected'."
        },
        template_summary: {
            template_summary_text: "This webhook will data-post call details over to Ringy, once the call is selected for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Ping Data' using the instructions provided by Ringy, including the 'TEMPLATE_SID' & 'TEMPLATE_AUTHTOKEN' values.\n\n2) Update the 'Ping Data' fields to include any required values you wish to pass.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "sid",
                property_name: "Ringy SID",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_SID"
            },
            {
                property_id: "auth_token",
                property_name: "Ringy AuthToken",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_AUTHTOKEN"
            }
        ]
    },
    relintex_data_post: {
        fields: {
            output_tag_prefix: 'relintex_datapost',

            ping_url: 'https://connect.relintex.net/api/v2/lead',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","authid":"TEMPLATE_AUTH_ID","authsecret":"TEMPLATE_AUTH_SECRET"}',
            ping_data: '{"ref_id":"[call_uuid]","first_name":"[first_name]","last_name":"[last_name]","address":"[address]","state":"[caller_state]","zip":"[caller_zip]","phone":"[nanp_caller_number]","email":"[email]","utm_src":"TEMPLATE_UTM_SOURCE","city":"[caller_city]"}',
            ping_output_map: '{"PingOutputMap":{}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '4'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Selected: When a buyer is selected'."
        },
        template_summary: {
            template_summary_text: "This webhook will data-post call details over to Relintex, once the call is selected for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Ping Headers' using the instructions provided by Relintex, including the 'TEMPLATE_AUTH_ID' & 'TEMPLATE_AUTH_SECRET' values.\n\n2) Update the 'Ping URL' fields to include any required values you wish to pass including the 'TEMPLATE_UTM_SOURCE' value.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "auth_id",
                property_name: "Relintex Auth ID",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_AUTH_ID"
            },
            {
                property_id: "auth_secret",
                property_name: "Relintex Auth Secret",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_AUTH_SECRET"
            },
            {
                property_id: "utm_src",
                property_name: "Relintex UTM Source ",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_UTM_SOURCE"
            }
        ]
    },
    next_level_direct_ping_post: {
        fields: {
            output_tag_prefix: 'nld_12345',

            ping_url: 'https://nexleveldirect.leadportal.com/new_api/api.php?Mode=ping&Format=JSON&Key=TEMPLATE_KEY&API_Action=iprSubmitLead&TYPE=45&SRC=TEMPLATE_SRC&Terminating_Phone=[nanp_caller_number]&Return_Best_Price=1&state=[caller_state]&zip=[caller_zip]&project=TEMPLATE_PROJECT&Origin_Phone=[nanp_caller_number]',
            ping_method: 'POST',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"bid":"response.price","timer":"response.min_duration","lead_id":"response.lead_id"}}',

            post_condition_key: 'bid',
            post_condition_operator: 'exists',
            post_condition_value: '0',

            post_url: 'https://nexleveldirect.leadportal.com/new_api/api.php?Mode=post&Format=JSON&Key=TEMPLATE_KEY&API_Action=iprSubmitLead&TYPE=9&SRC=TEMPLATE_SRC&Terminating_Phone=[nanp_caller_number]&Lead_ID=<podd_start>lead_id<podd_end>&Origin_Phone=[nanp_caller_number]',
            post_method: 'POST',
            post_headers: '',
            post_data: '',
            post_output_map: '{"PostOutputMap":{"post_status":"response.status"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the NextLevelDirect API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the NextLevelDirect request returns a valid transfer number, Retreaver will open the NextLevelDirect integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the NextLevelDirect integrated buyer.\n\n2) Update the 'Ping & Post URL' fields to include the 'TEMPLATE_KEY', 'TEMPLATE_SRC' & 'TEMPLATE_PROJECT' values provided by NextLevelDirect.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "nld_key",
                property_name: "NLD Key",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_KEY"
            },
            {
                property_id: "nld_src",
                property_name: "NLD Source",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_SRC"
            },
            {
                property_id: "nld_project",
                property_name: "NLD Project",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_PROJECT"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            },
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_post_status",
                "operator": "==",
                "value": "Success"
            }
        ]
    },
    modernize_ping_post: {
        fields: {
            output_tag_prefix: 'modernize_12345',

            ping_url: 'https://form-service-hs.qnst.com/calls/ping-post/pings',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"callerPhoneNumber":"[nanp_caller_number]","partnerSourceID":"TEMPLATE_SOURCE_ID","publisherSubID":"TEMPLATE_SUB_ID","service":"TEMPLATE_SERVICE","tagID":"TEMPLATE_TAG_ID","zip":"[caller_zip]"}',
            ping_output_map: '{"PingOutputMap":{"ping_token":"pingToken","bid":"data.price","timer":"data.callQualificationDurationInSecs"}}',

            post_condition_key: 'bid',
            post_condition_operator: 'exists',
            post_condition_value: '0',

            post_url: 'https://form-service-hs.qnst.com/calls/ping-post/posts',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json"}',
            post_data: '{"callerPhoneNumber":"[nanp_caller_number]","partnerSourceID":"TEMPLATE_SOURCE_ID","publisherSubID":"TEMPLATE_SUB_ID","service":"TEMPLATE_SERVICE","tagID":"TEMPLATE_TAG_ID","zip":"[caller_zip]","pingToken":"<podd_start>ping_token<podd_end>"}',
            post_output_map: '{"PostOutputMap":{"post_status":"status","number":"data.phoneNumber"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Modernize API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Modernize request returns a valid transfer number, Retreaver will open the Modernize integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Modernize integrated buyer.\n\n2) Update the 'Ping & Post Data' fields to include the 'TEMPLATE_SOURCE_ID', 'TEMPLATE_SUB_ID', 'TEMPLATE_SERVICE' & 'TEMPLATE_TAG_ID' values provided by Modernize.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "modernize_source_id",
                property_name: "Modernize Source ID",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_SOURCE_ID"
            },
            {
                property_id: "modernize_sub_id",
                property_name: "Modernize Sub ID",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_SUB_ID"
            },
            {
                property_id: "modernize_service",
                property_name: "Modernize Service",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_SERVICE"
            },
            {
                property_id: "modernize_tag_id",
                property_name: "Modernize Tag ID",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_TAG_ID"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    mutual_of_omaha_availability: {
        fields: {
            output_tag_prefix: 'moh_12345',

            ping_url: 'https://mutualofomaha.okta.com/oauth2/TEMPLATE_PING_URL/v1/token%3Fgrant_type=client_credentials&scope=dsc-availability-dscmetrics%3Aget',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded","Authorization":"Basic%20TEMPLATE_AUTHORIZATION_TOKEN"}',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"access_token":"access_token"}}',

            post_condition_key: 'access_token',
            post_condition_operator: 'exists',
            post_condition_value: '0',

            post_url: 'https://api.mutualofomaha.com/dsc-availability-eapi/v1/dscmetrics%3FqueueName=DSC_Lead',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json", "Authorization":"Bearer%20<podd_start>access_token<podd_end>"}',
            post_data: '{"caller_number":"[nanp_caller_number]", "zip":"[caller_zip]","city":"[caller_city]","state":"[caller_state]"}',
            post_output_map: '{"PostOutputMap":{"availability":"MetricResults%5B0%5D.Collections%5B1%5D.Value",%22status%22:%22Status%22}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a text tag type, enter the following: \n'OUTPUT_TAG_PREFIX_status' as the key, \n'equals' as the operator, \n'Agents are Available' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Mutual Of Omaha Agent Availability API to request a text 'status' response value representing the availability of agents ready to take a call. If the 'status' response value is 'Agents are Available', Retreaver will open the Mutual Of Omaha integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Mutual Of Omaha integrated buyer.\n\n2) Update the 'Ping URL' prefix, and the 'Ping Headers' 'TEMPLATE_AUTHORIZATION_TOKEN' to match with the instructions provided by Mutual Of Omaha.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "ping_url",
                property_name: "Mutual Of Omaha Ping URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://mutualofomaha.okta.com/oauth2/TEMPLATE_PING_URL"
            },
            {
                property_id: "authorization_token",
                property_name: "Mutual Of Omaha Auth Token",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_AUTHORIZATION_TOKEN"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_status",
                "operator": "==",
                "value": "Agents are Available"
            }
        ]
    },
    nld_availability: {
        fields: {
            output_tag_prefix: 'nld_12345',

            ping_url: 'https://nldavailbilityapi.com/relay?phone=[nanp_caller_number]&zipcode=[caller_zip]&campaign=TEMPLATE_CAMPAIGN&api_key=TEMPLATE_API_KEY',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"result":"result"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a text tag type, enter the following: \n'OUTPUT_TAG_PREFIX_result' as the key, \n'equals' as the operator, \n'true' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Next level Direct Agent Availability API to request a text 'result' response value representing the availability of agents ready to take a call. If the 'result' response value is 'true', Retreaver will open the Next level Direct integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Next level Direct integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Next level Direct.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "campaign",
                property_name: "NLD Campaign",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN"
            },
            {
                property_id: "api_key",
                property_name: "NLD API Key",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_result",
                "operator": "==",
                "value": "true"
            }
        ]
    },
    queueleads_availability: {
        fields: {
            output_tag_prefix: 'queue_leads_12345',

            ping_url: 'https://dev.queueleads.com/api/agent_check2/TEMPLATE_URL?phone=[nanp_caller_number]',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"agents_available":"agents_available"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a text tag type, enter the following: \n'OUTPUT_TAG_PREFIX_agents_available' as the key, \n'equals' as the operator, \n'true' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Queue Leads Agent Availability API to request a text 'result' response value representing the availability of agents ready to take a call. If the 'agents_available' response value is 'true', Retreaver will open the Queue Leads integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Queue Leads integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Queue Leads.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "campaign",
                property_name: "Queue Leads URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://dev.queueleads.com/api/agent_check2/TEMPLATE_URL"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_agents_available",
                "operator": "==",
                "value": "true"
            }
        ]
    },
    trackdrive_availability: {
        fields: {
            output_tag_prefix: 'trackdrive_12345',

            ping_url: 'https://TEMPLATE.trackdrive.com/api/v1/inbound_webhooks/ping/check_for_available_buyers?trackdrive_number=TEMPLATE_TRACKDRIVE_NUMBER&traffic_source_id=TEMPLATE_SOURCE_ID',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"success":"success"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a text tag type, enter the following: \n'OUTPUT_TAG_PREFIX_success' as the key, \n'equals' as the operator, \n'true' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the TrackDrive Agent Availability API to request a text 'success' response value representing the availability of agents ready to take a call. If the 'success' response value is 'true', Retreaver will open the TrackDrive integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the TrackDrive integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by TrackDrive.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "url",
                property_name: "TrackDrive URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://TEMPLATE.trackdrive.com/api/v1/inbound_webhooks/ping/check_for_available_buyers?trackdrive_number=TEMPLATE_TRACKDRIVE_NUMBER&traffic_source_id=TEMPLATE_SOURCE_ID"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_success",
                "operator": "==",
                "value": "true"
            }
        ]
    },
    specialweave_availability: {
        fields: {
            output_tag_prefix: 'specialweave_12345',

            ping_url: 'https://specialweave.online/api/TEMPLATE_USER',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"call_status":"call_status"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a text tag type, enter the following: \n'OUTPUT_TAG_PREFIX_call_status' as the key, \n'equals' as the operator, \n'accept' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the SpecialWeave Agent Availability API to request a text 'call_status' response value representing the availability of agents ready to take a call. If the 'call_status' response value is 'accept', Retreaver will open the SpecialWeave integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the SpecialWeave integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by SpecialWeave.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "user",
                property_name: "SpecialWeave User",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_USER"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_call_status",
                "operator": "==",
                "value": "accept"
            }
        ]
    },
    selectquote_suppression: {
        fields: {
            output_tag_prefix: 'selectquote_12345',

            ping_url: 'https://dsapi.selectquotelabs.com/getsupression',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","x-api-key":"TEMPLATE_X_API_KEY"}',
            ping_data: '{"ani":"[nanp_caller_number]","campaignId":TEMPLATE_CAMPAIGN_ID}',
            ping_output_map: '{"PingOutputMap":{"accepted":"accepted"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_accepted' as the key, \n'greater than' as the operator, \n'0' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Select Quote Suppression Check API to request a numeric 'accepted' response value representing a suppression check response. If the 'accepted' response value is above 1, Retreaver will open the Select Quote integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Select Quote integrated buyer.\n\n2) Update the 'Ping Headers' 'TEMPLATE_X_API_Key' and the 'Ping Data' 'TEMPLATE_CAMPAIGN_ID' field to match with the instructions provided by Select Quote.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "x_api_key",
                property_name: "SelectQuote X-API-KEY",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_X_API_KEY"
            },
            {
                property_id: "campaign_id",
                property_name: "SelectQuote Campaign ID",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_ID"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_accepted",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    svg_availability: {
        fields: {
            output_tag_prefix: 'svg_12345',

            ping_url: 'https://leads.svg-api.com/v1/inbound-ping',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","x-api-key":"TEMPLATE_X_API_KEY"}',
            ping_data: '{"leadSource":"TEMPLATE_LEADSOURCE","phone":"[nanp_caller_number]"}',
            ping_output_map: '{"PingOutputMap":{"accept":"accept"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a text tag type, enter the following: \n'OUTPUT_TAG_PREFIX_accept' as the key, \n'equals' as the operator, \n'true' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the SpringVentureGroup Agent Availability API to request a text 'accept' response value representing the availability of agents ready to take a call. If the 'accept' response value is 'true', Retreaver will open the SpringVentureGroup integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the SpringVentureGroup integrated buyer.\n\n2) Update the 'Ping Headers' 'TEMPLATE_X_API_KEY' and 'Ping_Data' 'CAMPAIGN_LEADSOURCE' fields to match with the instructions provided by SpringVentureGroup.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "x_api_key",
                property_name: "SVG X-API-Key",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_X_API_KEY"
            },
            {
                property_id: "lead_source",
                property_name: "SVG LeadSource",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_LEADSOURCE"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_accept",
                "operator": "==",
                "value": "true"
            }
        ]
    },
    nextelco_availability: {
        fields: {
            output_tag_prefix: 'nextelco_12345',

            ping_url: 'https://api.app.nextelco.io/api/CallCenter/TEMPLATE_URL/availableAgentsCount?campaign_id=TEMPLATE_CAMPAIGN_ID&period=thisYear&key=TEMPLATE_KEY',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"total":"data.total"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_total' as the key, \n'greater than' as the operator, \n'0' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Nextelco Agent Availability API to request a numeric 'total' response value representing the number of agents ready to take a call. If the 'total' response value is above 0, Retreaver will open the Nextelco integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Nextelco integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Nextelco.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "url",
                property_name: "Nextelco API Url",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://api.app.nextelco.io/api/CallCenter/TEMPLATE_URL/availableAgentsCount?"
            },
            {
                property_id: "campaign_id",
                property_name: "Nextelco Campaign ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_ID"
            },
            {
                property_id: "key",
                property_name: "Nextelco Key",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_KEY"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_total",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    nextgenict_availability: {
        fields: {
            output_tag_prefix: 'nextgenict_12345',

            ping_url: 'https://automate.nextgenict.com/webhook/TEMPLATTE_URL?tag=TEMPLATE_TAG',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"available_agents":"availableAgents"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_available_agents' as the key, \n'greater than' as the operator, \n'0' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Nextgenict Agent Availability API to request a numeric 'available_agents' response value representing the number of agents ready to take a call. If the 'available_agents' response value is above 0, Retreaver will open the Nextgenict integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Nextgenict integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Nextgenict.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "url",
                property_name: "Nextgenict API Url",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://automate.nextgenict.com/webhook/TEMPLATTE_URL?tag=TEMPLATE_TAG"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_available_agents",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    sabal_availability: {
        fields: {
            output_tag_prefix: 'sabal_12345',

            ping_url: 'https://api.sabalgrp.com/availability/index.php?state=[caller_state]',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded","X-API-Key":"TEMPLATE_X_API_KEY"}',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"ready":"response.ready"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_ready' as the key, \n'greater than' as the operator, \n'0' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Sabal Agent Availability API to request a numeric 'ready' response value representing the number of agents ready to take a call. If the 'ready' response value is above 0, Retreaver will open the Sabal integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Sabal integrated buyer.\n\n2) Update the 'Ping Headers' 'TEMPLATE_X_API_KEY' field to match with the instructions provided by Sabal.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "x_api_key",
                property_name: "Sabal X-API-KEY",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_X_API_KEY"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_ready",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    trestle_validation: {
        fields: {
            output_tag_prefix: 'trestle_12345',

            ping_url: 'https://api.trestleiq.com/3.0/phone_intel?phone=[nanp_caller_number]',
            ping_method: 'GET',
            ping_headers: '{"x-api-key":"TEMPLATE_X_API_KEY"}',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"is_valid":"is_valid"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a text tag type, enter the following: \n'OUTPUT_TAG_PREFIX_is_valid' as the key, \n'equal' as the operator, \n'true' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Trestle IQ Validation API to request a text 'is_valid' response value representing if this caller is valid. If the 'is_valid' response value is 'true', Retreaver will open the Trestle integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Trestle integrated buyer.\n\n2) Update the 'Ping Headers' 'TEMPLATE_X_API_KEY' field to match with the instructions provided by Trestle.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "x_api_key",
                property_name: "Trestle X-API-KEY",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_X_API_KEY"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_is_valid",
                "operator": "==",
                "value": "true"
            }
        ]
    },
    talkroute_ping: {
        fields: {
            output_tag_prefix: 'talkroute_12345',

            ping_url: 'https://talkroute.blinkrepo.in/v1/publisher/TEMPLATE_URL.json',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"CID":"[caller_number]","exposeCallerId":"yes","publisherInboundCallId":"TEMPLATE_PUBLISHER_CALLID"}',
            ping_output_map: '{"PingOutputMap":{"bid":"bidAmount","timer":"requiredDuration","number":"destinationNumber"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the TalkRoute API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the TalkRoute request returns a valid transfer number, Retreaver will open the TalkRoute integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the TalkRoute integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by TalkRoute, then update the 'Ping Data' 'TEMPLATE_PUBLISHER_CALLID' field as well.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "url",
                property_name: "TalkRoute URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://talkroute.blinkrepo.in/v1/publisher/TEMPLATE_URL.json"
            },
            {
                property_id: "call_id",
                property_name: "TalkRoute Publisher CallID",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_PUBLISHER_CALLID"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    svg_ping: {
        fields: {
            output_tag_prefix: 'svg_12345',

            ping_url: 'https://leads.svg-api.com/v1/dynamic-ping',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","x-api-key":"TEMPLATE_X_API_KEY"}',
            ping_data: '{"first":"[first_name]","last":"[last_name]","zip":"[caller_zip]","state":"[caller_state]","phone":"[nanp_caller_number]","leadSource":"TEMPLATE_LEAD_SOURCE","trustedFormToken":"[trusted_form_token]","og_leads_pii_id":"[call_uuid]"}',
            ping_output_map: '{"PingOutputMap":{"bid":"response"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: 'bid',
            revshare_modifier_percentage: '0.01'
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n3) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n4) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the SVG API to request for a potential conversion bid. If the SVG request returns a valid bid, Retreaver will open the SVG integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the SVG integrated buyer.\n\n2) Update the 'TEMPLATE_X_API_KEY' in the 'Ping Headers' and then update the 'TEMPLATE_LEAD_SOURCE' values in the 'Ping Data' field with the values provided by SVG.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_key",
                property_name: "SVG X-API-Key",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_X_API_KEY"
            },
            {
                property_id: "source_value",
                property_name: "SVG Lead Source",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_LEAD_SOURCE"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    salesriver_ping: {
        fields: {
            output_tag_prefix: 'salesriver_12345',

            ping_url: 'https://api.salesriver.com/calls/ping?product_id=TEMPLATE_PRODUCT_ID&affiliate_id=TEMPLATE_AFFILIATE_ID&caller_number=[nanp_caller_number]&first_name=[first_name]&last_name=[last_name]&email=[email]&street_address=[address]&city=[caller_city]&state=[caller_state]&postal_code=[caller_zip]',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"number":"call_reservation.inbound_number"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the SalesRiver API to request for a potential transfer number. If the SalesRiver request returns a valid transfer number, Retreaver will open the SalesRiver integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the SalesRiver integrated buyer.\n\n2) Update the 'Ping Url' 'TEMPLATE_PRODUCT_ID' and 'TEMPLATE_AFFILIATE_ID' fields using the instructions provided by SalesRiver.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "product_id",
                property_name: "SalesRiver Product ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_PRODUCT_ID"
            },
            {
                property_id: "affiliate_id",
                property_name: "SalesRiver Affiliate ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_AFFILIATE_ID"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            }
        ]
    },
    visiqua_ping_post: {
        fields: {
            output_tag_prefix: 'visiqua_12345',

            ping_url: 'https://api.callstoconvert.com/api/callAPI',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"campaign_token":"TEMPLATE_CAMPAIGN_TOKEN","caller_id":"[nanp_caller_number]","zip_code":"[caller_zip]"}',
            ping_output_map: '{"PingOutputMap":{"bid":"payout","timer":"duration","publisher_ping_id":"publisher_ping_id","advertiser_ping_id":"advertiser_ping_id"}}',

            post_condition_key: 'bid',
            post_condition_operator: 'is_greater_than',
            post_condition_value: '0',

            post_url: 'https://api.callstoconvert.com/api/postAPI',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json"}',
            post_data: '{"publisher_ping_id":"<podd_start>publisher_ping_id<podd_end>","advertiser_ping_id":"<podd_start>advertiser_ping_id<podd_end>","caller_id":"[nanp_caller_number]","first_name":"[fname]","last_name":"[lname]","address":"[address1]","city":"[caller_city]","state":"[caller_state]","zip_code":"[caller_zip]","jornaya_lead_id":"UniversalLeadID"}',
            post_output_map: '{"PostOutputMap":{"number":"DID"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Visiqua API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Visiqua request returns a valid transfer number, Retreaver will open the Visiqua integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Visiqua integrated buyer.\n\n2) Update the 'Ping Data' 'TEMPLATE_CAMPAIGN_TOKEN' field to match with the instructions provided by Visiqua.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "campaign_token",
                property_name: "Visiqua Campaign Token",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_TOKEN"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    tortx_ping_post: {
        fields: {
            output_tag_prefix: 'tortx_12345',

            ping_url: 'https://api.tortx.law/external/bids/request',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","Ocp-Apim-Subscription-Key":"TEMPLATE_SUBSCRIPTION_KEY"}',
            ping_data: '{"subscription-key":"TEMPLATE_SUBSCRIPTION_KEY","IsTest":"0","ClaimType":"Personal Injury","TrafficType":"Inbound Call","IncidentState":"[caller_state]","ClaimantPhone":"[nanp_caller_number]","SourceId":"TEMPLATE_SOURCE_ID","IsPrequalified":"True"}',
            ping_output_map: '{"PingOutputMap":{"bid_id":"Value.BidId","bid":"Value.BidAmount"}}',

            post_condition_key: 'bid',
            post_condition_operator: 'is_greater_than',
            post_condition_value: '0',

            post_url: 'https://api.tortx.law/external/bids/<podd_start>bid_id<podd_end>/accept',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json","Ocp-Apim-Subscription-Key":"TEMPLATE_SUBSCRIPTION_KEY"}',
            post_data: '{"ClaimantFirstName":"[first_name]","ClaimantLastName":"[last_name]","ClaimantEmail":"[email]","Channel":"Display","AtFault":"No","Attorney":"No","ChangeAttorney":"","IncidentPosition":"Driver","Settlement":"No","ClaimantRelationship":"Self","PublisherId":"TEMPLATE_PUBLISHER_ID"}',
            post_output_map: '{"PostOutputMap":{"number":"TransferDID"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Tortx API to request for a potential conversion bid and dynamic transfer number. If the Tortx request returns a valid transfer number, Retreaver will open the Tortx integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Tortx integrated buyer.\n\n2) Update the 'Ping/Post and Ping Data' 'TEMPLATE_SUBSCRIPTION_KEY' fields, as well as the 'Ping Data' 'TEMPLATE_SOURCE_ID' field, and the 'Post Data' 'TEMPATE_PUBLISHER_ID' fields to match with the instructions provided by Tortx.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "subscription_key",
                property_name: "Tortx Subscription Key",
                fields_to_replace: [
                    "ping_headers",
                    "post_headers",
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_SUBSCRIPTION_KEY"
            },
            {
                property_id: "source_id",
                property_name: "Tortx Source ID",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_SOURCE_ID"
            },
            {
                property_id: "publisher_id",
                property_name: "Tortx Publisher ID",
                fields_to_replace: [
                    "post_data"
                ],
                replacement_token: "TEMPLATE_PUBLISHER_ID"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    leadportal_ping: {
        fields: {
            output_tag_prefix: 'leadportal_12345',

            ping_url: 'https://TEMPLATE_URL.leadportal.com/new_api/api.php?Mode=full&Format=JSON&Key=TEMPLATE_KEY&API_Action=TEMPLATE_ACTION&TYPE=TEMPLATE_TYPE&SRC=TEMPLATE_SOURCE&Terminating_Phone=TEMPLATE_TERMINATING_PHONE&Return_Best_Price=1&Origin_Phone=[nanp_caller_number]&Origin_Phone_Area_Code=[nanp_caller_number_area_code]&State=[caller_state]&ZIP=[caller_zip]',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"bid":"response.price","timer":"response.min_duration","lead_id":"response.lead_id","status":"response.status"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and ensure the 'Number' matches the terminating phone value: 'TEMPLATE_TERMINATING_PHONE'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Tag your buyer with 'OUTPUT_TAG_PREFIX_bid' 'is_greater_than' '0' to ensure the buyer is only routed when a bid is returned.\n\n7) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the LeadPortal API to request for a potential conversion bid and conversion timer. If the LeadPortal request returns a valid bid, Retreaver will open the LeadPortal integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the LeadPortal integrated buyer.\n\n2) Update the 'Ping URL' including: TEMPLATE_URL, TEMPLATE_KEY, TEMPLATE_ACTION, TEMPLATE_TYPE, TEMPLATE_SOURCE & TEMPLATE_TERMINATING_PHONE fields with the values provided by LeadPortal.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "leadportal_url",
                property_name: "LeadPortal URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://TEMPLATE_URL.leadportal.com/new_api/api.php"
            },
            {
                property_id: "api_key",
                property_name: "LeadPortal Key",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_KEY"
            },
            {
                property_id: "api_action",
                property_name: "LeadPortal API Action",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_ACTION"
            },
            {
                property_id: "type",
                property_name: "LeadPortal Type",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_TYPE"
            },
            {
                property_id: "source",
                property_name: "LeadPortal Source",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_SOURCE"
            },
            {
                property_id: "terminating_phone",
                property_name: "LeadPortal Terminating Phone",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_TERMINATING_PHONE"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    datapass_home_ping_post: {
        fields: {
            output_tag_prefix: 'datapass_home_12345',

            ping_url: 'https://datapass.insure.com/calls/home/3.0?applyConfig=DEFAULT&quadTag=TEMPLATE_QUADTAG',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"action":"ping","data":{"consumerInfo":{"state":"[caller_state]","homePhone":"[nanp_caller_number]"},"propertyInfo":{"propertyState":"[caller_state]","propertyZip":"[caller_zip]"},"typeOfInsurance":"Homeowners","currentlyInsured":"Yes"},"metaData":{"callDirection":"Inbound"}}',
            ping_output_map: '{"PingOutputMap":{"ping_id":"pingId","ping_status":"status","bid":"commission","timer":"callQualificationDuration"}}',

            post_condition_key: 'bid',
            post_condition_operator: 'is_greater_than',
            post_condition_value: '0',

            post_url: 'https://datapass.insure.com/calls/home/3.0?applyConfig=DEFAULT&quadTag=TEMPLATE_QUADTAG',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json"}',
            post_data: '{"action":"post","data":{"consumerInfo":{"state":"[caller_state]","homePhone":"[nanp_caller_number]"},"propertyInfo":{"propertyState":"[caller_state]","propertyZip":"[caller_zip]"},"typeOfInsurance":"Homeowners","currentlyInsured":"Yes"},"metaData":{"callDirection":"Inbound","pingId":"<podd_start>ping_id<podd_end>"}}',
            post_output_map: '{"PostOutputMap":{"post_status":"status"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and ensure the transfer number matches the value provided by Quinstreet.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Tag your buyer with 'OUTPUT_TAG_PREFIX_bid' 'is_greater_than' '0' to ensure the buyer is only routed when a bid is returned.\n\n7) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Quinstreet Datapass API to request for a potential conversion bid and conversion timer. If the Quinstreet Datapass request returns a valid bid, Retreaver will open the Quinstreet Datapass integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Quinstreet Datapass integrated buyer.\n\n2) Update the 'Ping URL' 'TEMPLATE_QUADTAG' field with the values provided by Quinstreet Datapass.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "quadtag",
                property_name: "Quinstreet QuadTag",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_QUADTAG"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    datapass_auto_ping_post: {
        fields: {
            output_tag_prefix: 'datapass_auto_12345',

            ping_url: 'https://datapass.insure.com/calls/auto/3.0?applyConfig=DEFAULT&quadTag=TEMPLATE_QUADTAG',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"action":"ping","data":{"drivers":%5B{"state":"[caller_state]","homePhone":"[nanp_caller_number]"}%5D,"priorPolicyInfo":{"currentlyInsured":"Yes"}},"metaData":{"callDirection":"Inbound"}}',
            ping_output_map: '{"PingOutputMap":{"ping_id":"pingId","ping_status":"status","bid":"commission","timer":"callQualificationDuration"}}',

            post_condition_key: 'bid',
            post_condition_operator: 'is_greater_than',
            post_condition_value: '0',

            post_url: 'https://datapass.insure.com/calls/auto/3.0?applyConfig=DEFAULT&quadTag=TEMPLATE_QUADTAG',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json"}',
            post_data: '{"action":"post","data":{"drivers":%5B{"homePhone":"[nanp_caller_number]","state":"[caller_state]"}%5D,"priorPolicyInfo":{"currentlyInsured":"Yes"}},"metaData":{"leadIdToken":"[leadidtag]","trustedFormToken":"[trustedformtag]","callDirection":"Inbound","pingId":"<podd_start>ping_id<podd_end>"}}',
            post_output_map: '{"PostOutputMap":{"post_status":"status"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and ensure the transfer number matches the value provided by Quinstreet.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Tag your buyer with 'OUTPUT_TAG_PREFIX_bid' 'is_greater_than' '0' to ensure the buyer is only routed when a bid is returned.\n\n7) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Quinstreet Datapass API to request for a potential conversion bid and conversion timer. If the Quinstreet Datapass request returns a valid bid, Retreaver will open the Quinstreet Datapass integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Quinstreet Datapass integrated buyer.\n\n2) Update the 'Ping URL' 'TEMPLATE_QUADTAG' field with the values provided by Quinstreet Datapass.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "quadtag",
                property_name: "Quinstreet QuadTag",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_QUADTAG"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    datapass_life_ping_post: {
        fields: {
            output_tag_prefix: 'datapass_life_12345',

            ping_url: 'https://datapass.insure.com/calls/life/3.0?applyConfig=DEFAULT&quadTag=TEMPLATE_QUADTAG',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"action":"ping","data":{"state":"[caller_state]","priorPolicyInfo":{"insuranceType":"WholeLife"}},"metaData":{"callDirection":"Inbound"}}',
            ping_output_map: '{"PingOutputMap":{"ping_id":"pingId","ping_status":"status","bid":"commission","timer":"callQualificationDuration"}}',

            post_condition_key: 'bid',
            post_condition_operator: 'is_greater_than',
            post_condition_value: '0',

            post_url: 'https://datapass.insure.com/calls/life/3.0?applyConfig=DEFAULT&quadTag=TEMPLATE_QUADTAG',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json"}',
            post_data: '{"action":"post","data":{"state":"[caller_state]","primaryPhone":"[nanp_caller_number]","priorPolicyInfo":{"insuranceType":"WholeLife"}},"metaData":{"callDirection":"Inbound","pingId":"<podd_start>ping_id<podd_end>"}}',
            post_output_map: '{"PostOutputMap":{"post_status":"status"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and ensure the transfer number matches the value provided by Quinstreet.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Tag your buyer with 'OUTPUT_TAG_PREFIX_bid' 'is_greater_than' '0' to ensure the buyer is only routed when a bid is returned.\n\n7) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Quinstreet Datapass API to request for a potential conversion bid and conversion timer. If the Quinstreet Datapass request returns a valid bid, Retreaver will open the Quinstreet Datapass integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Quinstreet Datapass integrated buyer.\n\n2) Update the 'Ping URL' 'TEMPLATE_QUADTAG' field with the values provided by Quinstreet Datapass.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "quadtag",
                property_name: "Quinstreet QuadTag",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_QUADTAG"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    tld_agent_availability_vendor_ping: {
        fields: {
            output_tag_prefix: 'tld_12345',

            ping_url: 'https://pros.tldcrm.com/api/vendor/ping/TEMPLATE/TEMPLATE/[caller_number_digits]',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"ready":"ready"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_ready' as the key, \n'greater than' as the operator, \n'0' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the TLD Agent Availability API to request a numeric 'ready' response value representing the number of agents ready to take a call. If the 'ready' response value is above 0, Retreaver will open the TLD integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the TLD integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by TLD.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "tld_url",
                property_name: "TLD API Url",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://pros.tldcrm.com/api/vendor/ping/TEMPLATE/TEMPLATE/[caller_number_digits]"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_ready",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    convoso_data_post: {
        fields: {
            output_tag_prefix: 'convoso_12345',

            ping_url: 'https://api.convoso.com/v1/leads/insert?auth_token=TEMPLATE_AUTH_TOKEN&list_id=TEMPLATE_LIST_ID',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"lead_id":"data.lead_id"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '4'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Selected: When a buyer is selected'.\n\n2) Use the tag wizard to apply a buyer ID tag on the webhook 'matches' field, this ensures that this webhook only triggers when a specific buyer is selected."
        },
        template_summary: {
            template_summary_text: "This webhook will post any listed and available caller data fields over to Convoso's database if the caller is routed to a specified buyer."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Convoso integrated buyer.\n\n2) Update the 'Ping Url' using the instructions provided by Convoso, be sure to replace the TEMPLATE_AUTH_TOKEN and TEMPLATE_LIST_ID values with the values provided by Convoso and append any other desired data attributes to pass at the end of the URL.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "convoso_url",
                property_name: "Convoso Url",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://api.convoso.com/v1/leads/insert?auth_token=TEMPLATE_AUTH_TOKEN&list_id=TEMPLATE_LIST_ID"
            }
        ]
    },
    open_home_pros_ping: {
        fields: {
            output_tag_prefix: 'open_home_pros_12345',

            ping_url: 'https://code.openhomepros.com/ping/calls-openhome/bths?supplier=TEMPLATE_SUPPLIER&phone=[nanp_caller_number]&zip_code=[caller_zip]',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"bid":"bid","timer":"call_min_duration"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n3) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n4) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the OpenHomePros API to request for a potential conversion bid and conversion timer. If the OpenHomePros request returns a valid bid, Retreaver will open the OpenHomePros integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the OpenHomePros integrated buyer.\n\n2) Update the 'TEMPLATE_SUPPLIER' on the 'Ping URL' field with the value provided by OpenHomePros.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_supplier",
                property_name: "OpenHomePros Supplier",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_SUPPLIER"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    caller_ready_availability: {
        fields: {
            output_tag_prefix: 'caller_ready_12345',

            ping_url: 'https://calling.callerready.com/api/ci/CanRouteCall?inboundPhone=TEMPLATE_INBOUND_PHONE&leadPhone=[nanp_caller_number]',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"canrouterow":"CanRouteNow"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_canrouterow' as the key, \n'greater than' as the operator, \n'0' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Caller Ready Agent Availability API to request a numeric 'canrouterow' response value representing if an agent is ready to take a call. If the 'canrouterow' response value is above 0, Retreaver will open the Caller Ready integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Caller Ready integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Caller Ready by supplying a TEMPLATE_INBOUND_PHONE value.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "caller_ready_inbound_phone",
                property_name: "Caller Ready Inbound Phone",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_INBOUND_PHONE"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_canrouterow",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    agent_tech_availability: {
        fields: {
            output_tag_prefix: 'agent_tech_12345',

            ping_url: 'https://dialer.agenttech.io/api.php?action=TEMPLATE_ACTION&queue=TEMPLATE_QUEUE&callerid=[nanp_caller_number]',
            ping_method: 'POST',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"available_agents":"target_queues[0].available_agents"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_available_agents' as the key, \n'greater than' as the operator, \n'0' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Agent Tech Agent Availability API to request a numeric 'available_agents' response value representing if an agent is ready to take a call. If the 'available_agents' response value is above 0, Retreaver will open the Agent Tech integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Agent Tech integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Agent Tech by supplying a TEMPLATE_ACTION & TEMPLATE_QUEUE values.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "agent_tech_action",
                property_name: "Agent Tech Action",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_ACTION"
            },
            {
                property_id: "agent_tech_queue",
                property_name: "Agent Tech Queue",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_QUEUE"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_available_agents",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    mileradius_ping_post: {
        fields: {
            output_tag_prefix: '33mileradius_12345',

            ping_url: 'https://calls.33mileradius.com/api/v3/?password=TEMPLATE_PASSWORD&zip=[caller_zip]&duration=1',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"supported":"supported","ping_id":"ping_id","bid":"amount","timer":"duration"}}',

            post_condition_key: 'supported',
            post_condition_operator: 'is_equal',
            post_condition_value: '1',

            post_url: 'https://calls.33mileradius.com/api/v3/?password=TEMPLATE_PASSWORD&callback&ping_id=<podd_start>ping_id<podd_end>',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            post_data: '',
            post_output_map: '{"PostOutputMap":{"number":"trackingNumber"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the 33MileRadius API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the 33MileRadius request returns a valid transfer number, Retreaver will open the 33MileRadius integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the 33MileRadius integrated buyer.\n\n2) Update the 'Ping & Post URL' fields to include the 'TEMPLATE_PASSWORD' value provided by 33MileRadius.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "33MileRadiusPassword",
                property_name: "33 Mile Radius Password",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "TEMPLATE_PASSWORD"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    genesys_usw2_availability: {
        fields: {
            output_tag_prefix: 'genesys_usw2_12345',

            ping_url: 'https://login.usw2.pure.cloud/oauth/token?client_id=TEMPLATE_CLIENT_ID&client_secret=TEMPLATE_CLIENT_SECRET&grant_type=client_credentials',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"access_token":"access_token"}}',

            post_condition_key: 'access_token',
            post_condition_operator: 'exists',
            post_condition_value: '0',

            post_url: 'https://api.usw2.pure.cloud/api/v2/analytics/queues/observations/query',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json", "Authorization":"Bearer%20<podd_start>access_token<podd_end>"}',
            post_data: '{"filter":{"predicates":[{"dimension":"queueId","operator":"matches","value":"TEMPLATE_QUEUE_ID"}],"type":"and"},"metrics":["oOnQueueUsers"]}',
            post_output_map: '{"PostOutputMap":{"idle_count":"results[0].data[1].stats.count","qualifier":"results[0].data[1].qualifier"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a text tag type, enter the following: \n'OUTPUT_TAG_PREFIX_qualifier' as the key, \n'equals' as the operator, \n'Idle' as the value.\n\n4) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_idle_count' as the key, \n'equals to or is greater than' as the operator, \n'1' as the value.\n\n5) Press 'add' on the tag wizard.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Genesys USW2 Availability API to request a text 'idle_count' response value representing the availability of agents ready to take a call. If the 'idle_count' response value is above 0, Retreaver will open the Genesys USW2 integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Genesys USW2 integrated buyer.\n\n2) Update the 'Ping URL' 'TEMPLATE_CLIENT_ID'  & 'TEMPLATE_CLIENT_SECRET' parameters, and the 'Post URL' 'TEMPLATE_QUEUE_ID' parameters to match with the instructions provided by Genesys USW2.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "client_id",
                property_name: "USW2 Client Id",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_CLIENT_ID"
            },
            {
                property_id: "client_secret",
                property_name: "USW2 Client Secret",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_CLIENT_SECRET"
            },
            {
                property_id: "queue_id",
                property_name: "USW2 Queue ID",
                fields_to_replace: [
                    "post_data"
                ],
                replacement_token: "TEMPLATE_QUEUE_ID"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_idle_count",
                "operator": ">=",
                "value": "1"
            },
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_qualifier",
                "operator": "==",
                "value": "Idle"
            }
        ]
    },
    phonely_ping_post: {
        fields: {
            output_tag_prefix: 'phonely_12345',

            ping_url: 'https://db.phonely.ai/api/pay-per-call/request/ping',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","Authorization":"Bearer%20TEMPLATE_BEARER_TOKEN"}',
            ping_data: '{"caller_id":"[caller_number]","service_category":"TEMPLATE_SERVICE_CATEGORY","zip_code":"[caller_zip]"}',
            ping_output_map: '{"PingOutputMap":{"success":"success","request_id":"request_id"}}',

            post_condition_key: 'success',
            post_condition_operator: 'is_equal',
            post_condition_value: 'true',

            post_url: 'https://db.phonely.ai/api/pay-per-call/request/accept',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json","Authorization":"Bearer%20TEMPLATE_BEARER_TOKEN"}',
            post_data: '{"request_id":"<podd_start>request_id<podd_end>","caller_id":"[caller_number]"}',
            post_output_map: '{"PostOutputMap":{"timer":"time","bid":"price","number":"did"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Phonely API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Phonely request returns a valid transfer number, Retreaver will open the Phonely integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Phonely integrated buyer.\n\n2) Update the 'Ping & Post Header' fields to include the 'TEMPLATE_BEARER_TOKEN', and the 'TEMPLATE_SERVICE_CATEGORY' in the 'Ping_Data' field using the values provided by Phonely.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "phonely_bearer_token",
                property_name: "Phonely Bearer Token",
                fields_to_replace: [
                    "ping_headers",
                    "post_headers"
                ],
                replacement_token: "TEMPLATE_BEARER_TOKEN"
            },
            {
                property_id: "phonely_service_category",
                property_name: "Phonely Service Category",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_SERVICE_CATEGORY"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    track_drive_ping_post_p1: {
        fields: {
            output_tag_prefix: 'trackdrive_12345',
            ping_url: 'https://TEMPLATE_URL.trackdrive.com/api/v1/inbound_webhooks/ping/TEMPLATE_URL?trackdrive_number=+18551231234&traffic_source_id=4444&caller_id=[nanp_caller_number]',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"status":"status","ping_id":"buyers[0].ping_id","timer":"buyers[0].offer_conversion_duration OR current_conversion_duration","bid":"buyers[0].offer_conversion_payout"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',
            payout_output_tag: '',
            payout_modifier_percentage: '',
            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the TrackDrive API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the TrackDrive request returns a valid transfer number, Retreaver will open the TrackDrive integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the TrackDrive integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by TrackDrive, update the 'TEMPLATE_URL' and then update the 'trackdrive_number' and 'traffic_source_id' url parameters with the values provided by TrackDrive.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "trackdrive_ping_url",
                property_name: "TrackDrive Ping URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://TEMPLATE_URL.trackdrive.com/api/v1/inbound_webhooks/ping/TEMPLATE_URL"
            },
            {
                property_id: "trackdrive_number",
                property_name: "TrackDrive Number",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "+18551231234"
            },
            {
                property_id: "traffic_source_id",
                property_name: "TrackDrive Source ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "4444"
            },
            {
                property_id: "timer_output_tag",
                property_name: "TrackDrive Conversion Timer Output Key",
                fields_to_replace: [
                    "ping_output_map"
                ],
                replacement_token: "offer_conversion_duration OR current_conversion_duration"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            },
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_status",
                "operator": "==",
                "value": "accepted"
            }
        ]
    },
    track_drive_ping_post_p2: {
        fields: {
            output_tag_prefix: 'trackdrive_12345',
            ping_url: 'https://TEMPLATE_URL.trackdrive.com/api/v1/inbound_webhooks/post/TEMPLATE_URL?trackdrive_number=+18551231234&traffic_source_id=4444&caller_id=[nanp_caller_number]&ping_id=[trackdrive_12345_ping_id]',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/x-www-form-urlencoded"}',
            ping_data: '{}',
            ping_output_map: '{"PingOutputMap":{"forwarding_number_status":"forwarding_number_status","number":"forwarding_number"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',
            payout_output_tag: '',
            payout_modifier_percentage: '',
            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '4',
            hold_call: true
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'When a handler is selected' and check the 'Hold caller until completion' checkbox.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the TrackDrive API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the TrackDrive request returns a valid transfer number, Retreaver will open the TrackDrive integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the TrackDrive integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by TrackDrive, update the 'TEMPLATE_URL' and then update the 'trackdrive_number' and 'traffic_source_id' url parameters with the values provided by TrackDrive.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix",
                    "ping_url"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "trackdrive_post_url",
                property_name: "TrackDrive Post URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://TEMPLATE_URL.trackdrive.com/api/v1/inbound_webhooks/post/TEMPLATE_URL"
            },
            {
                property_id: "trackdrive_number",
                property_name: "TrackDrive Number",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "+18551231234"
            },
            {
                property_id: "traffic_source_id",
                property_name: "TrackDrive Source ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "4444"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_number",
                "operator": "=~",
                "value": ".+"
            }
        ]
    },
    d2m_ping_post_p1: {
        fields: {
            output_tag_prefix: 'd2m_12345',

            ping_url: 'https://offers.d2m-api.com/v1/offers/search?FsearchType=broad&category=TEMPLATE_CATEGORY&subCategory=TEMPLATE_SUBCATEGORY&keyword=&brandName=&channel=&radius=&city=[caller_city]&state=[caller_state]&limit=10',
            ping_method: 'GET',
            ping_headers: '{"x-api-key":"TEMPLATE_API_KEY"}',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"id":"0.id","timer":"0.billableDuration","bid":"0.advertiserPayout"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the D2M API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the D2M request returns a valid transfer number, Retreaver will open the D2M integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the D2M integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by D2M, update the 'TEMPLATE_CATEGORY' and then update the 'TEMPLATE_SUBCATEGORY' url parameters with the values provided by D2M.\n\n3) Update the ping header fields to match with the instructions provided by D2M, update the 'TEMPLATE_API_KEY' with the value provided by D2M.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "category",
                property_name: "D2M Category",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_CATEGORY"
            },
            {
                property_id: "subcategory",
                property_name: "D2M Subcategory",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_SUBCATEGORY"
            },
            {
                property_id: "api_key",
                property_name: "D2M X-API-Key",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    d2m_ping_post_p2: {
        fields: {
            output_tag_prefix: 'd2m_12345',

            ping_url: 'https://offers.d2m-api.com/v1/offers/callback?request_id=[d2m_12345_id]',
            ping_method: 'POST',
            ping_headers: '{"Content-Type": "application/x-www-form-urlencoded","x-api-key":"TEMPLATE_API_KEY"}',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"number":"number"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '4',
            hold_call: true
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'When a handler is selected' and check the 'Hold caller until completion' checkbox.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the D2M API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the D2M request returns a valid transfer number, Retreaver will open the D2M integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the D2M integrated buyer.\n\n2) Update the ping header fields to match with the instructions provided by D2M, update the 'TEMPLATE_API_KEY' with the value provided by D2M.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix",
                    "ping_url"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_key",
                property_name: "D2M X-API-Key",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_number",
                "operator": "=~",
                "value": ".+"
            }
        ]
    },
    intelelead_ping_post_p1: {
        fields: {
            output_tag_prefix: 'intelelead_12345',

            ping_url: 'https://www.intelelead.com/offer',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","api-key":"TEMPLATE_API_KEY","dp-key":"TEMPLATE_DP_KEY","vendor":"TEMPLATE_VENDOR"}',
            ping_data: '{"demographics":{"last_name":null,"first_name":null,"address":{"zipcode":"[caller_zip]","address1":"Unavailable","state":"[caller_state]","address2":null,"city":"[caller_city]"},"ani":"[nanp_caller_number]","send_to":"TEMPLATE_SEND_TO","additional_data":{"trusted_form_url":null,"offer_type":"exclusive","age":null,"lead_type":"Call","campaign":"WT"}}}',
            ping_output_map: '{"PingOutputMap":{"result":"result","bid":"price","offer_id":"offer_id"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n3) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n4) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Intelelead API to request for a potential conversion bid. If the Intelelead request returns a valid bid, Retreaver will open the Intelelead integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Intelelead integrated buyer.\n\n2) Update the 'Ping Headers' field to include the 'api key', 'dp key' and 'vendor' values provided by Intelelead.\n\n3) Update the 'Ping Data' fields to include the 'send to' value provided by Intelelead.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_key",
                property_name: "Intelelead API Key",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            },
            {
                property_id: "dp_key",
                property_name: "Intelelead DP Key",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_DP_KEY"
            },
            {
                property_id: "vendor",
                property_name: "Intelelead Vendor",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_VENDOR"
            },

            {
                property_id: "send_to",
                property_name: "Intelelead Send To",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_SEND_TO"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    intelelead_ping_post_p2: {
        fields: {
            output_tag_prefix: 'intelelead_12345',

            ping_url: 'https://www.intelelead.com/lead',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","api-key":"TEMPLATE_API_KEY","dp-key":"TEMPLATE_DP_KEY","vendor":"TEMPLATE_VENDOR"}',
            ping_data: '{"offer_id":"[intelelead_12345_offer_id]","demographics":{"last_name":null,"first_name":null,"address":{"zipcode":"[caller_zip]","address1":"Unavailable","state":"[caller_state]","address2":null,"city":"[caller_city]"},"ani":"[nanp_caller_number]","send_to":"TEMPLATE_SEND_TO","additional_data":{"trusted_form_url":null,"offer_type":"exclusive","age":null,"lead_type":"Call","campaign":"WT"}}}',
            ping_output_map: '{"PingOutputMap":{"message":"message"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '4',
            hold_call: true
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'When a handler is selected' and check the 'Hold caller until completion' checkbox.\n\n2) Edit your Retreaver buyer and modify the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n3) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n4) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Intelelead API to request for a potential conversion bid. If the Intelelead request returns a valid bid, Retreaver will open the Intelelead integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Intelelead integrated buyer.\n\n2) Update the 'Ping Headers' field to include the 'api key', 'dp key' and 'vendor' values provided by Intelelead.\n\n3) Update the 'Ping Data' fields to include the 'send to' value provided by Intelelead.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix",
                    "ping_data"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_key",
                property_name: "Intelelead API Key",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            },
            {
                property_id: "dp_key",
                property_name: "Intelelead DP Key",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_DP_KEY"
            },
            {
                property_id: "vendor",
                property_name: "Intelelead Vendor",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_VENDOR"
            },

            {
                property_id: "send_to",
                property_name: "Intelelead Send To",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_SEND_TO"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_message",
                "operator": "=~",
                "value": ".+"
            }
        ]
    },
    lead_api_px_ping_post_p1: {
        fields: {
            output_tag_prefix: 'leads_api_px_12345',

            ping_url: 'https://leadapi.px.com/api/call/ping',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","Accept":"application/json"}',
            ping_data: '{"ApiToken":"TEMPLATE_API_TOKEN","Vertical":"TEMPLATE_VERTICAL","SubId":"TEMPLATE_SUB_ID","OfferId":"TEMPLATE_OFFER_ID","OriginalUrl":"Not applicable","ContactData":{"PhoneNumber":"[caller_number]","ZipCode":"[caller_zip]"}}',
            ping_output_map: '{"PingOutputMap":{"ping_TransactionId":"TransactionId","ping_Success":"Success","bid":"Payout","ping_Sold":"Sold"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria. \n\n3) For the 'Seconds Tag' field, set the value to a hardcoded value to match with your affiliate partner agreement.\n\n4) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n5) Scroll to the 'Tag List' section, then press the 'wizard' button.\n\n6) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_bid' as the key, \n'greater than' as the operator, \n'0' as the value.\n\n7) Press 'add' on the tag wizard.\n\n8) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Lead PX API to request for a potential conversion bid. If the Lead PX request returns a valid conversion bid, Retreaver will open the Lead PX integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Lead PX integrated buyer.\n\n2) Update the 'Ping Data' fields including:\nTEMPLATE_API_TOKEN\nTEMPLATE_VERTICAL\nTEMPLATE_SUB_ID\nTEMPLATE_OFFER_ID\nMake sure to match with the instructions provided by Lead PX.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_token",
                property_name: "Lead PX API Token",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_API_TOKEN"
            },
            {
                property_id: "vertical",
                property_name: "Lead PX Vertical",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_VERTICAL"
            },
            {
                property_id: "sub_id",
                property_name: "Lead PX Sub ID",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_SUB_ID"
            },
            {
                property_id: "offer_id",
                property_name: "Lead PX Offer ID",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_OFFER_ID"
            }

        ],
        template_required_buyer_tags: [
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_ping_Success",
                "operator": "==",
                "value": "true"
            },
            {
                "category": "numeric",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    lead_api_px_ping_post_p2: {
        fields: {
            output_tag_prefix: 'leads_api_px_12345',

            ping_url: 'https://leadapi.px.com/api/call/post',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","Accept":"application/json"}',
            ping_data: '{"TransactionId":"[leads_api_px_12345_ping_TransactionId]","ApiToken":"TEMPLATE_API_TOKEN","Vertical":"TEMPLATE_VERTICAL","SubId":"TEMPLATE_SUB_ID","OfferId":"TEMPLATE_OFFER_ID","OriginalUrl":"Not applicable","ContactData":{"ZipCode":"[caller_zip]","PhoneNumber":"[caller_number]"}}',
            ping_output_map: '{"PingOutputMap":{"post_TransactionId":"TransactionId","post_Success":"Success","post_payout":"Payout","post_Sold":"Sold"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '4',
            hold_call: true
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'When a handler is selected' and check the 'Hold caller until completion' checkbox.\n\n2) Edit your Retreaver buyer and scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria. \n\n3) For the 'Seconds Tag' field, set the value to a hardcoded value to match with your affiliate partner agreement.\n\n4) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n5) Scroll to the 'Tag List' section, then press the 'wizard' button.\n\n6) Using a numeric tag type, enter the following: \n'OUTPUT_TAG_PREFIX_bid' as the key, \n'greater than' as the operator, \n'0' as the value.\n\n7) Press 'add' on the tag wizard.\n\n8) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Lead PX API to request for a potential conversion bid. If the Lead PX request returns a valid conversion bid, Retreaver will open the Lead PX integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Lead PX integrated buyer.\n\n2) Update the 'Ping Data' fields including:\nTEMPLATE_API_TOKEN\nTEMPLATE_VERTICAL\nTEMPLATE_SUB_ID\nTEMPLATE_OFFER_ID\nMake sure to match with the instructions provided by Lead PX.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix",
                    "ping_data"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_token",
                property_name: "Lead PX API Token",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_API_TOKEN"
            },
            {
                property_id: "vertical",
                property_name: "Lead PX Vertical",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_VERTICAL"
            },
            {
                property_id: "sub_id",
                property_name: "Lead PX Sub ID",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_SUB_ID"
            },
            {
                property_id: "offer_id",
                property_name: "Lead PX Offer ID",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_OFFER_ID"
            }

        ],
        template_required_buyer_tags: [
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_post_Success",
                "operator": "=~",
                "value": ".+"
            }
        ]
    },
    leadspedia_ping_post_p1: {
        fields: {
            output_tag_prefix: 'leadspedia_12345',

            ping_url: 'https://TEMPLATE_URL.leadspediatrack.com/call-ping.do?lp_campaign_id=TEMPLATE_CAMPAIGN_ID&lp_campaign_key=TEMPLATE_CAMPAIGN_KEY&caller_id=[nanp_caller_number]&zip_code=[caller_zip]',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"status":"status","request_number_url":"request_number_url"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Leadspedia API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Leadspedia request returns a valid transfer number, Retreaver will open the Leadspedia integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Leadspedia integrated buyer.\n\n2) Update the 'Ping URL' field to match with the instructions provided by Leadspedia, update the 'TEMPLATE_URL' and then update the 'TEMPLATE_CAMPAIGN_ID' and 'TEMPLATE_CAMPAIGN_KEY' url parameters with the values provided by Leadspedia.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "leadspedia_ping_url",
                property_name: "Leadspedia Ping URL",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "https://TEMPLATE_URL.leadspediatrack.com/call-ping.do"
            },
            {
                property_id: "leadspedia_campaign_id",
                property_name: "Leadspedia Campaign ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_ID"
            },
            {
                property_id: "leadspedia_campaign_key",
                property_name: "Leadspedia Campaign Key",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_KEY"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_status",
                "operator": "==",
                "value": "Accepted"
            }
        ]
    },
    leadspedia_ping_post_p2: {
        fields: {
            output_tag_prefix: 'leadspedia_12345',

            ping_url: '[leadspedia_12345_request_number_url]',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"number":"number","timer":"duration","bid":"payout"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '4',
            hold_call: true
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'When a handler is selected' and check the 'Hold caller until completion' checkbox.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Leadspedia API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Leadspedia request returns a valid transfer number, Retreaver will open the Leadspedia integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Leadspedia integrated buyer.\n\n2) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix",
                    "ping_url"
                ],
                replacement_token: "12345"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            },
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_number",
                "operator": "=~",
                "value": ".+"
            }
        ]
    },
    connexone_availability: {
        fields: {
            output_tag_prefix: 'connexone_12345',

            ping_url: 'https://TEMPLATE-URL.io.connexone.cloud/oauth2/token?client_id=TEMPLATE_CLIENT_ID&client_secret=TEMPLATE_CLIENT_SECRET&grant_type=client_credentials',
            ping_method: 'POST',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"access_token":"access_token"}}',

            post_condition_key: 'access_token',
            post_condition_operator: 'exists',
            post_condition_value: '0',

            post_url: 'https://TEMPLATE-URL.io.connexone.cloud/user/availability?voice_only=true&voice_queue_id=TEMPLATE_VOICE_QUEUE_ID',
            post_method: 'GET',
            post_headers: '{"X-Authorization":"Basic TEMPLATE_X_AUTHORIZATION_TOKEN","Authorization":"Bearer%20<podd_start>access_token<podd_end>"}',
            post_data: '',
            post_output_map: '{"PostOutputMap":{"available":"data.available"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a text tag type, enter the following: \n'OUTPUT_TAG_PREFIX_available' as the key, \n'equals' as the operator, \n'true' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the ConnexOne Agent Availability API to request a text 'available' response value representing the availability of agents ready to take a call. If the 'status' response value is 'true', Retreaver will open the ConnexOne integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the ConnexOne integrated buyer.\n\n2) Update the 'Ping & Post URL' prefixes, the 'TEMPLATE_CLIENT_ID','TEMPLATE_CLIENT_SECRET',TEMPLATE_VOICE_QUEUE_ID & TEMPLATE_X_AUTHORIZATION_TOKEN values to match with the instructions provided by ConnexOne.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "connexone_url",
                property_name: "ConnexOne URL Prefix",
                fields_to_replace: [
                    "ping_url",
                    "post_url"
                ],
                replacement_token: "https://TEMPLATE-URL.io.connexone.cloud/"
            },
            {
                property_id: "client_id",
                property_name: "ConnexOne Client Id",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_CLIENT_ID"
            },
            {
                property_id: "client_secret",
                property_name: "ConnexOne Client Secret",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_CLIENT_SECRET"
            },
            {
                property_id: "voice_queue_id",
                property_name: "ConnexOne Voice Queue Id",
                fields_to_replace: [
                    "post_url"
                ],
                replacement_token: "TEMPLATE_VOICE_QUEUE_ID"
            },
            {
                property_id: "x_authorization_token",
                property_name: "ConnexOne X Authorization Token",
                fields_to_replace: [
                    "post_headers"
                ],
                replacement_token: "TEMPLATE_X_AUTHORIZATION_TOKEN"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_available",
                "operator": "==",
                "value": "true"
            }
        ]
    },
    all_calls_ping_post: {
        fields: {
            output_tag_prefix: 'allcalls_12345',

            ping_url: 'https://allcalls.io/api/agent-availability',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"phone":"[nanp_caller_number]","vertical":"TEMPLATE_VERTICAL","affiliate_id":"TEMPLATE_AFFILIATE_ID","api_key":"TEMPLATE_API_KEY"}',
            ping_output_map: '{"PingOutputMap":{"availability":"availability","ping_id":"unique_ping-ID","price":"price"}}',

            post_condition_key: 'availability',
            post_condition_operator: 'is_equal',
            post_condition_value: 'YES',

            post_url: 'https://allcalls.io/api/agent-availability/confirm',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json"}',
            post_data: '{"caller-ID":"[nanp_caller_number]","ping-ID":"<podd_start>ping_id<podd_end>"}',
            post_output_map: '{"PostOutputMap":{"status":"status"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: '',
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and scroll to the 'Tag List' section, then press the 'wizard' button.\n\n3) Using a text tag type, enter the following: \n'OUTPUT_TAG_PREFIX_availability' as the key, \n'equals' as the operator, \n'YES' as the value.\n\n4) Press 'add' on the tag wizard.\n\n5) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the AllCalls Agent Availability API to request a text 'availability' response value representing the availability of agents ready to take a call. If the 'availability' response value is 'YES', Retreaver will open the AllCalls integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the AllCalls integrated buyer.\n\n2) Update the following 'Ping Data' fields: 'TEMPLATE_VERTICAL', 'TEMPLATE_AFFILIATE_ID' & 'TEMPLATE_API_KEY' to match with the instructions provided by AllCalls.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "vertical",
                property_name: "AllCalls Vertical",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_VERTICAL"
            },
            {
                property_id: "affiliate_id",
                property_name: "AllCalls Affiliate Id",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_AFFILIATE_ID"
            },
            {
                property_id: "api_key",
                property_name: "AllCalls API Key",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_API_KEY"
            },

        ],
        template_required_buyer_tags: [
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_availability",
                "operator": "==",
                "value": "YES"
            },
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_status",
                "operator": "==",
                "value": "YES"
            },
        ]
    },
    unik_clr_availability: {
        fields: {
            output_tag_prefix: 'clr_availability_12345',

            ping_url: 'https://us-central1-callersio.cloudfunctions.net/ping?c=TEMPLATE_CAMPAIGN_ID&n=[nanp_caller_number]&state=[caller_state]&dialed=[called_number]',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"ping":"ping","dynamic_sip_number":"sip","available_count":"available_count"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_dynamic_sip_number]'.\n\n3) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the CLR Agent Availability API to request a 'ping' & 'dynamic_sip_number' value representing if an agent is available to take a call. If the 'ping' value is 'true' & the 'dynamic_sip_number' response is present, Retreaver will route the call using the 'dynamic_sip_number' for the CLR integrated buyer."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the CLR integrated buyer.\n\n2) Update the following 'Ping URL' parameter: 'TEMPLATE_CAMPAIGN_ID' to match with the instructions provided by CLR.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "campaign_id",
                property_name: "CLR Campaign ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_CAMPAIGN_ID"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_dynamic_sip_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "text",
                "key": "OUTPUT_TAG_PREFIX_ping",
                "operator": "==",
                "value": "true"
            },
        ]
    },
    ringpartner_ping_post: {
        fields: {
            output_tag_prefix: 'ringpartner_12345',

            ping_url: 'https://forms.ringpartner.com/calls/ping',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"publisher_id":"TEMPLATE_PUBLISHER_ID","vertical_id":"TEMPLATE_VERTICAL_ID","is_test":"0","zip":"[zip]","ip":"[ip_address]","phone":"[nanp_caller_number]"}',
            ping_output_map: '{"PingOutputMap":{"ping_bid":"bid","lead_id":"lead_id"}}',

            post_condition_key: 'ping_bid',
            post_condition_operator: 'is_greater_than',
            post_condition_value: '0',

            post_url: 'https://forms.ringpartner.com/calls/post',
            post_method: 'POST',
            post_headers: '{"Content-Type":"application/json"}',
            post_data: '{"publisher_id":"TEMPLATE_PUBLISHER_ID","vertical_id":"TEMPLATE_VERTICAL_ID","is_test":"0","lead_id":"<podd_start>lead_id<podd_end>","first_name":"[first_name]","last_name":"[last_name]","phone":"[nanp_caller_number]","email":"[email]","zip":"[zip]","ip":"[ip_address]","trusted_form_url":"[trusted_form_url]","jornaya_id":"[jornaya_id]"}',
            post_output_map: '{"PostOutputMap":{"number":"phone_number","bid":"bid","timer":"conversion_duration"}}',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the RingPartner API to request for a potential transfer number, conversion bid and conversion timer. If the RingPartner request returns a valid transfer number, Retreaver will open the RingPartner integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the RingPartner integrated buyer.\n\n2) Update the 'Ping Data' and 'Post Data' including: TEMPLATE_PUBLISHER_ID, TEMPLATE_VERTICAL_ID fields with the values provided by RingPartner.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "publisher_id",
                property_name: "RingPartner Publisher Id",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_PUBLISHER_ID"
            },
            {
                property_id: "vertical_id",
                property_name: "RingPartner Vertical Id",
                fields_to_replace: [
                    "ping_data",
                    "post_data"
                ],
                replacement_token: "TEMPLATE_VERTICAL_ID"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    mojo_rtb_ping: {
        fields: {
            output_tag_prefix: 'mojo_rtb_12345',

            ping_url: 'rtb.moja.cloud/inbound_rtb/TEMPLATE_RTB_ID?CALLER_ID=[nanp_caller_number]&zip=[caller_zip]',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"number":"eligible_routes.0.number","bid":"eligible_routes.0.payout","timer":"eligible_routes.0.duration"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Mojo RTB API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the Mojo request returns a valid transfer number, Retreaver will open the Mojo integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Mojo integrated buyer.\n\n2) Update the 'TEMPLATE_RTB_ID' on the 'Ping URL' field with the value provided by Mojo.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "rtb_id",
                property_name: "Mojo RTB ID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_RTB_ID"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    hive_hq_transfer_ping: {
        fields: {
            output_tag_prefix: 'hivehq_transfer_12345',

            ping_url: 'https://buyers.ps-api.hivehq.co/v1/transfer',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json"}',
            ping_data: '{"key":"TEMPLATE_KEY","phone":"[nanp_caller_number]","first_name":"[first_name]","last_name":"[last_name]","address":"[address]","city":"[caller_city]","state":"[caller_state]","zip":"[caller_zip]","email":"[email]","gender":"[gender]","date_of_birth":"[date_of_birth]"}',
            ping_output_map: '{"PingOutputMap":{"number":"data.transfer_number"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Press 'Update Call Buyer' to update your buyer and complete the integration."
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the Hive HQ Agent Transfer API to request a dynamic 'transfer_number' representing if an agent is available to take a call. If the 'transfer_number' response is present, Retreaver will route the call using the 'reservation_number' for the Hive HQ integrated buyer."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Hive HQ integrated buyer.\n\n2) Update the following 'Ping Data' parameter: 'TEMPLATE_KEY' to match with the instructions provided by Hive HQ.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "api_key",
                property_name: "HiveHQ API Key",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_KEY"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            }
        ]
    },
    market_match_ping: {
        fields: {
            output_tag_prefix: 'market_match_12345',

            ping_url: 'https://api.marketmatch.ai/affiliates/ping?phone=[nanp_caller_number]&zip=[caller_zip]&state=[caller_state]&uuid=TEMPLATE_UUID',
            ping_method: 'GET',
            ping_headers: '',
            ping_data: '',
            ping_output_map: '{"PingOutputMap":{"bid":"result.price","timer":"result.bufferTime","number":"result.did"}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '9'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Start: When a call comes in' or 'Pass-through ping' for RTB.\n\n2) Edit your Retreaver buyer and modify the 'Number' field to '[OUTPUT_TAG_PREFIX_number]'.\n\n3) Scroll down to the 'Conversion Criteria' section then add a new buyer conversion criteria.\n\n4) For the 'Seconds Tag' field, set the value to 'OUTPUT_TAG_PREFIX_timer'.\n\n5) For the 'Revenue Tag' field, set the value to 'OUTPUT_TAG_PREFIX_bid'.\n\n6) Press 'Update Call Buyer' to update your buyer and complete the integration.\n\nNOTE: If you cannot create a buyer conversion criteria, or update the 'Seconds Tag' & 'Revenue Tag' fields, ask Retreaver support to enable these features for your account. "
        },
        template_summary: {
            template_summary_text: "This webhook will communicate with the MarketMatch API to request for a potential conversion bid, conversion timer and dynamic transfer number. If the MarketMatch request returns a valid transfer number, Retreaver will open the MarketMatch integrated buyer for routing."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the MarketMatch integrated buyer.\n\n2) Update the following 'Ping URL' 'TEMPLATE_UUID' parameter to match with the instructions provided by the MarketMatch provider.\n\n3) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "uuid",
                property_name: "MarketMatch UUID",
                fields_to_replace: [
                    "ping_url"
                ],
                replacement_token: "TEMPLATE_UUID"
            }
        ],
        template_required_buyer_tags: [
            {
                "category": "number",
                "key": "[OUTPUT_TAG_PREFIX_number]",
                "operator": "=~",
                "value": ".+"
            },
            {
                "category": "timer",
                "key": "OUTPUT_TAG_PREFIX_timer",
                "operator": "<=",
                "value": "3600"
            },
            {
                "category": "bid",
                "key": "OUTPUT_TAG_PREFIX_bid",
                "operator": ">=",
                "value": "1"
            }
        ]
    },
    call_tools_datapost: {
        fields: {
            output_tag_prefix: 'call_tools_12345',

            ping_url: 'https://west-4.calltools.io/api/contacts/',
            ping_method: 'POST',
            ping_headers: '{"Content-Type":"application/json","Authorization":"Token%20TEMPLATE_AUTH_TOKEN"}',
            ping_data: '{"first_name":"[first_name]","last_name":"[last_name]","phone":"[nanp_caller_number]","address":"[address]","city":"[caller_city]","state":"[caller_state]","zip_code":"[caller_zip]","dob":"[dob]","source":"TEMPLATE_SOURCE"}',
            ping_output_map: '{"PingOutputMap":{}}',

            post_condition_key: '',
            post_condition_operator: '',
            post_condition_value: '',

            post_url: '',
            post_method: '',
            post_headers: '',
            post_data: '',
            post_output_map: '',

            payout_output_tag: '',
            payout_modifier_percentage: '',

            revshare_output_tag: '',
            revshare_modifier_percentage: ''
        },
        webhook_trigger_type: {
            trigger_type_value: '4'
        },
        webhook_setup_instructions: {
            webhook_setup_instructions_text: "1) Set the webhook trigger to 'Selected: When a buyer is selected'.\n\n2) Use the tag wizard to apply a buyer ID tag on the webhook 'matches' field, this ensures that this webhook only triggers when a specific buyer is selected."
        },
        template_summary: {
            template_summary_text: "This webhook will post any listed and available caller data fields over to Call Tools's database if the caller is routed to a specified buyer."
        },
        template_steps: {
            template_steps_text: "1) Update the 'Output Tag Prefix' field by changing '12345' to match with the Retreaver system buyer ID representing the Call Tools integrated buyer.\n\n2) Update the 'Ping Header' authorization token.\n\n3) Update the 'Ping Data' 'TEMPLATE_SOURCE' value using the instructions provided by Call Tools.\n\n4) Submit this form then continue with the generated 'Webhook Setup Instructions' below."
        },
        template_required_parameters: [
            {
                property_id: "retreaver_buyer_id",
                property_name: "Retreaver Buyer Id",
                fields_to_replace: [
                    "output_tag_prefix"
                ],
                replacement_token: "12345"
            },
            {
                property_id: "token",
                property_name: "Call Tools Auth Token",
                fields_to_replace: [
                    "ping_headers"
                ],
                replacement_token: "TEMPLATE_AUTH_TOKEN"
            },
            {
                property_id: "source",
                property_name: "Call Tools Source",
                fields_to_replace: [
                    "ping_data"
                ],
                replacement_token: "TEMPLATE_SOURCE"
            }
        ]
    },
};
